module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showWhatmoreBaner) ? _c('div', {
    staticClass: "whatmore-base"
  }, [_c('div', {
    attrs: {
      "id": "whatmoreShopId",
      "data": _vm.contentKey
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreProductId",
      "data": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreExtensionType",
      "data": "product"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreVariantId",
      "data": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreEmbedAppPositionPortrait",
      "data": "right"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreEmbedAppHorizontalPaddingPortrait",
      "data": "5"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreEmbedAppVerticalPaddingPortrait",
      "data": "140"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreEmbedAppVideoPlayerSizePortrait",
      "data": "60"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreEmbedAppPositionLandscape",
      "data": "right"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreEmbedAppHorizontalPaddingLandscape",
      "data": "5"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreEmbedAppVerticalPaddingLandscape",
      "data": "129"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreEmbedAppVideoPlayerSizeLandscape",
      "data": "76"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreEmbedAppUseVariant",
      "data": "false"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreEmbedAppVideoTitle",
      "data": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "whatmoreIsInDesignMode",
      "data": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "whatmore-template-type",
    attrs: {
      "data": "template-embed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "whatmore-widget",
    attrs: {
      "data": "embed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "whatmore-render-root"
  })]) : _vm._e(), _vm._v(" "), (_vm.newDesignMweb && !_vm.$parent.isDesktop) ? _c('div', [_c('ProductDetailMweb', {
    attrs: {
      "colorWebHeader": _vm.colorWebHeader,
      "isColorWebEnable": _vm.isColorWebEnable,
      "prodRedirection": _vm.prodRedirection
    }
  })], 1) : _c('div', [(_vm.isNewDesign) ? _c('div', {
    ref: "bannerSection",
    staticClass: "new-design-banner text-center"
  }, [(_vm.$parent.isDesktop) ? _c('div', [_c('div', {
    staticClass: "round-back-icon round-share-icon",
    on: {
      "click": _vm.goToPreviousPage
    }
  }, [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/back-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "round-share-icon",
    on: {
      "click": function($event) {
        _vm.newDesignShare = !_vm.newDesignShare
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/share-icon.png",
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.newDesignShare) ? _c('div', {
    staticClass: "sharebtns f22 new-design-share",
    on: {
      "click": _vm.open
    }
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.tss + _vm.$route.path,
      "title": _vm.product.product
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(!_vm.$parent.isDesktop) ? _c('network', {
            staticClass: "showmobile disinline f24",
            attrs: {
              "network": "whatsapp",
              "id": "whatsapp"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-whatsapp"
          })]) : _vm._e(), _vm._v(" "), _c('a', {
            staticClass: "nonecolor showdesktoplinine",
            attrs: {
              "href": 'https://web.whatsapp.com/send?text=https://www.thesouledstore.com' + this.$route.fullPath,
              "target": "_blank",
              "rel": "noopener noreferrer",
              "id": "whatsapp"
            }
          }, [_c('span', {
            staticClass: "fa fa-whatsapp"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "facebook",
              "id": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-facebook-square"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter",
              "id": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-twitter"
          })]), _vm._v(" "), _c('a', {
            staticClass: "nonecolor",
            attrs: {
              "href": "https://www.instagram.com/TheSouledStore/",
              "target": "_blank",
              "rel": "noopener noreferrer",
              "id": "instagram"
            }
          }, [_c('span', {
            staticClass: "fa fa-instagram"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e()]), _vm._v(" "), (!_vm.$parent.isDesktop) ? _c('div', {
    staticClass: "round-share-icon",
    on: {
      "click": _vm.shareNavigatorHandler
    }
  }, [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/share-icon.png",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('NewDesignBanner', {
    attrs: {
      "product": _vm.product,
      "isDesktop": _vm.$parent.isDesktop,
      "categoryWiseImages": _vm.product.images
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canonicalUrl0) ? _c('link', {
    attrs: {
      "rel": "canonical",
      "href": _vm.canonicalUrl0
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canonicalUrl) ? _c('link', {
    attrs: {
      "rel": "canonical",
      "href": _vm.canonicalUrl
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSizeChartVisible) ? _c('SizeChartModal', {
    attrs: {
      "selectedVariantSize": _vm.selectedProductVariant && _vm.selectedProductVariant.size,
      "sizeChartDetailData": _vm.productWiseSizeChartData,
      "stock": _vm.product.prod_type === 6 ? _vm.commonComboVariantsProd ? [].concat( _vm.commonComboVariantsProd.variant ) : (_vm.selectedComboSizeChart && _vm.selectedComboSizeChart.option && _vm.selectedComboSizeChart.option.variants && [].concat( _vm.selectedComboSizeChart.option.variants )) || [] : [].concat( _vm.product.variant ),
      "productImage": _vm.product.prod_type === 6 ? _vm.commonComboVariantsProd ? [].concat( this.getComboVarientImages(_vm.commonComboVariantsProd.images_new) ) : (_vm.selectedComboSizeChart && _vm.selectedComboSizeChart.variant && this.getComboVarientImages(_vm.selectedComboSizeChart.variant.images_new)) || [] : [].concat( _vm.product.images ),
      "sizeChartTitle": _vm.product.prod_type === 6 ? _vm.commonComboVariantsProd ? _vm.commonComboVariantsProd.category : _vm.selectedComboSizeChart && _vm.selectedComboSizeChart.variant && _vm.selectedComboSizeChart.variant.category : _vm.product.category,
      "prodType": _vm.product.prod_type,
      "sizeChartVisibility": _vm.sizeChartVisibilityHandler,
      "productDetails": _vm.product,
      "isCommonComboVariantProd": _vm.commonComboVariantsProd
    },
    on: {
      "updateVariant": function($event) {
        _vm.updateSizeVariant($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.productZoomMobile) ? _c('ProductZoomModal', {
    attrs: {
      "imgArray": _vm.product.images,
      "activeImg": _vm.magActiveimg,
      "videoUrl": _vm.product.video_url,
      "isVideoActive": _vm.product.show_video_url,
      "videoIndex": _vm.product.video_url_index
    },
    on: {
      "closeProdZoomModal": function($event) {
        _vm.closeProductZoomModal($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sizevalid),
      expression: "!sizevalid"
    }],
    staticClass: "pAdded"
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('Loader')], 1) : (_vm.notFound && !_vm.isLoading && _vm.noProductAllowed) ? _c('div', [_c('NoProductFoundListing', {
    attrs: {
      "wishlistItemsIDs": _vm.wishlistItemsIDs,
      "updateWishlist": _vm.updateWishlist
    }
  })], 1) : _c('div', {
    staticClass: "productdetails conbottom"
  }, [(_vm.productSlug === 'bevarsi-kudka-tshirt') ? _c('div', {
    staticClass: "pagebanner doodleban pbg"
  }, [(this.$parent.isDesktop) ? _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/bevarsi-banner-desktop.jpg',
      "alt": "bevarsi-kudka-tshirt"
    }
  }) : _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/bevarsi-banner-mobile.jpg',
      "alt": "bevarsi-kudka-tshirt"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.bannerName && _vm.productSlug !== 'batman-active-wear-tshirt') ? _c('div', {
    staticClass: "pagebanner doodleban pbg"
  }, [(this.$parent.isDesktop) ? _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-desktop.jpg',
      "alt": _vm.bannerName
    }
  }) : _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-mobile.jpg',
      "alt": _vm.bannerName
    }
  })]) : (_vm.productSlug === 'batman-active-wear-tshirt' && _vm.now >= _vm.endDate) ? _c('div', {
    staticClass: "pagebanner doodleban pbg"
  }, [(this.$parent.isDesktop) ? _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-desktop.jpg',
      "alt": "batman-active-wear-tshirt"
    }
  }) : _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-mobile.jpg',
      "alt": "batman-active-wear-tshirt"
    }
  })]) : (_vm.productSlug === 'hourly-deals' && _vm.now >= _vm.endDate) ? _c('div', {
    staticClass: "pagebanner doodleban pbg"
  }, [(this.$parent.isDesktop) ? _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-desktop.jpg',
      "alt": "hourly-deals"
    }
  }) : _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.bannerName + '-mobile.jpg',
      "alt": "hourly-deals"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.gifName) ? _c('div', {
    staticClass: "pagebanner doodleban pbg"
  }, [(this.$parent.isDesktop) ? _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.gifName + '-desktop.jpg',
      "alt": _vm.gifName
    }
  }) : _c('img', {
    attrs: {
      "data-src": _vm.staticImg + 'banners/' + _vm.gifName + '-mobile.jpg',
      "alt": _vm.gifName
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showCountDown && _vm.$parent.isDesktop) ? _c('Countdown', {
    attrs: {
      "starttime": _vm.startDate,
      "endtime": _vm.endDate,
      "color": _vm.timerColor,
      "showTimer": _vm.showTimer,
      "pretext": _vm.liveSaleText,
      "showEarlyText": _vm.showEarlyText
    },
    on: {
      "getLiveSaleText": _vm.getSaleTextToShow
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isExclusive && _vm.showExcBar) ? _c('ExcBand', {
    attrs: {
      "checkedExcBox": _vm.isNotifyVisible,
      "showExcStyle": _vm.excBand.showExcStyle,
      "excBannerMsg": _vm.excBand.excText
    },
    on: {
      "addExc": _vm.addExclusiveToCartFromBand
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderPDP && _vm.bannerPlaceHolderPDP.status) ? _c('BannerPlaceHolderMsg', {
    attrs: {
      "bannerStyle": _vm.bannerPlaceHolderPDP && _vm.bannerPlaceHolderPDP.styles,
      "bannerMsg": _vm.bannerPlaceHolderPDP && _vm.bannerPlaceHolderPDP.text
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderPDPWithCat && _vm.bannerPlaceHolderPDPWithCat.status) ? _c('BannerPlaceHolderMsg', {
    attrs: {
      "bannerStyle": _vm.bannerPlaceHolderPDPWithCat && _vm.bannerPlaceHolderPDPWithCat.styles,
      "bannerMsg": _vm.bannerPlaceHolderPDPWithCat && _vm.bannerPlaceHolderPDPWithCat.text
    }
  }) : (_vm.productSlug === 'black-panther-proutility-backpack' && !_vm.isExclusive && !_vm.isSouledOut && _vm.now < _vm.endDate) ? _c('div', {
    staticClass: "text-center exclusive-bar"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('div', {
    staticClass: "customcheckbox mr-15 pointer",
    staticStyle: {
      "text-transform": "unset"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "giftwrap",
      "id": "giftwrap"
    },
    on: {
      "click": function($event) {
        _vm.addExclusiveToCart(_vm.EXCLUSIVE_PRODUCTS[2].prod_id)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0 pl-4",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.earlyAccessText))])])])]) : _vm._e(), _vm._v(" "), (_vm.productSlug === 'batman-3d-logo-tshirt' && _vm.now > _vm.startDate && _vm.now < _vm.endDate && !_vm.isExclusive) ? _c('div', {
    staticClass: "text-center exclusive-bar"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('div', {
    staticClass: "customcheckbox mr-15 pointer",
    staticStyle: {
      "text-transform": "unset"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "giftwrap",
      "id": "giftwrap"
    },
    on: {
      "click": function($event) {
        _vm.addExclusive(_vm.EXCLUSIVE_PRODUCTS[2].prod_id)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0 pl-4",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.earlyAccessText))])])])]) : _vm._e(), _vm._v(" "), (_vm.productSlug === 'batman-active-wear-tshirt' && _vm.now < _vm.endDate && _vm.now >= _vm.startDate) ? _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#3498db",
      "color": "#fff",
      "padding": "10px"
    }
  }, [(_vm.now >= _vm.startDate && _vm.now <= _vm.exclusiveDate) ? _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Early Access for Exclusive members opens at 10 AM on " + _vm._s(_vm.formatDate(_vm.exclusiveDate)))]) : (_vm.now >= _vm.exclusiveDate && _vm.isExclusive) ? _c('span', {
    staticStyle: {
      "font-size": "25px"
    }
  }, [_vm._v("Early Access is open for you")]) : (_vm.now >= _vm.exclusiveDate && !_vm.isExclusive) ? _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('div', {
    staticClass: "customcheckbox mr-15 pointer",
    staticStyle: {
      "text-transform": "unset"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "giftwrap",
      "id": "giftwrap"
    },
    on: {
      "click": function($event) {
        _vm.addExclusive(_vm.EXCLUSIVE_PRODUCTS[2].prod_id)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Become an member (" + _vm._s(_vm.currencySymbol) + " 199 / year) to Pre-Order this product right now at a " + _vm._s(_vm.currencySymbol) + " 100 discount")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.productSlug === 'batman-3d-logo-tshirt' && _vm.now >= _vm.exclusiveDate && _vm.now < _vm.endDate && _vm.isExclusive) ? _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "10px",
      "background-color": "rgb(217, 155, 0)"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "25px",
      "color": "#fff"
    }
  }, [_vm._v("\n            Early Access is Now Live\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container detailpage fullWidth"
  }, [(_vm.$parent.isDesktop) ? _c('div', {
    staticClass: "newbread"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._v("\n            /\n            "), (_vm.product.cat_breadcrum_name) ? _c('span', [_c('router-link', {
    attrs: {
      "to": '/explore/' + _vm.product.category_slug
    }
  }, [_vm._v(_vm._s(_vm.product.cat_breadcrum_name) + " ")]), _vm._v("/ ")], 1) : _vm._e(), _vm._v(" "), (_vm.product.firstname) ? _c('span', [_c('router-link', {
    attrs: {
      "to": '/artists/' + _vm.product.artist_slug
    }
  }, [_vm._v(_vm._s(_vm.product && _vm.product.firstname && _vm.product.firstname.replace('\u0099', '™')) + " ")]), _vm._v("/ ")], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }, [_vm._v("  " + _vm._s(_vm.product.product))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container detailpage fullWidth"
  }, [_c('div', {
    class: !_vm.isNewDesign ? 'row' : ''
  }, [(!_vm.isNewDesign) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "row mdproduct forDesktop",
    class: _vm.productSlug === 'justice-league-reversible-hoodie' && 'prelative'
  }, _vm._l((_vm.product.images), function(pr, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-2 pimg image-wrapper",
      class: {
        'col-md-6': _vm.product.images.length > 1
      },
      attrs: {
        "id": "pview"
      }
    }, [(_vm.$parent.isDesktop && _vm.product.video_url && _vm.product.show_video_url === 1 && (index === _vm.product.video_url_index)) ? _c('div', {
      staticStyle: {
        "height": "100%",
        "width": "100%"
      }
    }, [_c('VideoPlayer', {
      attrs: {
        "src": _vm.product.video_url,
        "poster": pr,
        "playVideo": _vm.bannerPlaceHolderForVideoAutoplay
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "expand",
      on: {
        "click": function($event) {
          _vm.magnify(_vm.product.video_url + '%video%' + pr, 0)
        }
      }
    }, [_c('img', {
      attrs: {
        "width": "18px",
        "src": "https://tss-static-images.gumlet.io/expand.png",
        "alt": "open fullscreen"
      }
    })])], 1) : _c('div', [_c('div', {
      directives: [{
        name: "lazyloadImage",
        rawName: "v-lazyloadImage"
      }],
      class: _vm.showBlur ? 'imgLink customFade' : _vm.productSlug === 'justice-league-reversible-hoodie' && 'show-views',
      style: (_vm.showBlur ? 'filter: blur(2px); width:100%;' : 'width:100%;')
    }, [_c('img', {
      directives: [{
        name: "imageBackground",
        rawName: "v-imageBackground",
        value: (_vm.isProdMounted ? '1080:1440' : ''),
        expression: "isProdMounted ? '1080:1440' : ''"
      }],
      ref: "imageRef",
      refInFor: true,
      staticClass: "pointer minProd",
      class: [{
        'customFade': !_vm.showBlur
      }, {
        'show-blur': _vm.product.is_blur
      }],
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "max-width": "410px"
      },
      attrs: {
        "rel": "preload",
        "data-url": _vm.prdImg + pr,
        "alt": _vm.altTagDisplay(index, _vm.product.product, _vm.product.category),
        "title": _vm.product.meta_title,
        "width": "410",
        "height": "546"
      },
      on: {
        "click": function($event) {
          _vm.magnify(_vm.prdImg + pr, index)
        }
      }
    }), _vm._v(" "), (_vm.bannerPlaceHolderForPdpTicker && _vm.product.tickers && _vm.product.tickers.length > 0 && _vm.currentTickerText && index === 0) ? _c('div', {
      staticClass: "pdp-ticker"
    }, [_c('span', [_vm._v(_vm._s(_vm.currentTickerText))])]) : _vm._e(), _vm._v(" "), (_vm.isOutOfStock) ? _c('div', {
      staticClass: "souled-out"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v("Souled Out")])]) : (_vm.isSouledOut && ['harry-potter-hufflepuff-sigil-scarf'].includes(_vm.productSlug)) ? _c('div', {
      staticClass: "coming-soon"
    }, [_vm._v("coming soon")]) : (_vm.isSouledOut) ? _c('div', {
      staticClass: "souledout"
    }) : _vm._e(), _vm._v(" "), (index === 0 && _vm.mockUpTag && Object.keys(_vm.mockUpTag).length) ? _c('div', {
      staticClass: "mockup-tag",
      class: _vm.getMockUpTagPositionClass(_vm.mockUpTag.tag_position)
    }, [_c('span', {
      style: ({
        backgroundColor: _vm.mockUpTag.background_color,
        color: _vm.mockUpTag.text_color
      })
    }, [_vm._v("\n                          " + _vm._s(_vm.mockUpTag.tag_name) + "\n                        ")])]) : _vm._e()]), _vm._v(" "), (new Date(_vm.endDate) > new Date(_vm.now) && _vm.checkDailyDropObjectExist) ? _c('div', {
      staticClass: "image-wrapper__product-status"
    }, [_c('p', [_vm._v(_vm._s(_vm.liveSaleText))]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "background-color": "#fff",
        "margin": "7px 0"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.productLiveDate.date)), _c('sup', [_vm._v(_vm._s(_vm.productLiveDate.dateSup))]), _vm._v(" " + _vm._s(_vm.productLiveDate.month && _vm.productLiveDate.month.toUpperCase()) + " " + _vm._s(_vm.productLiveDate.time && _vm.productLiveDate.time.toUpperCase()))])]) : _vm._e()]), _vm._v(" "), (_vm.showShopTheLook && _vm.product.image_coordinates && _vm.product.image_coordinates[_vm.modifyName(pr)] && _vm.product.image_coordinates[_vm.modifyName(pr)].length) ? _c('div', _vm._l((_vm.product.image_coordinates[_vm.modifyName(pr)]), function(cordinate, cordinateIndex) {
      return _c('div', {
        key: cordinateIndex,
        staticClass: "green-dot",
        style: ({
          left: _vm.calculatePercentage(cordinate.x, 'x', index),
          top: _vm.calculatePercentage(cordinate.y, 'y', index)
        }),
        on: {
          "click": function($event) {
            _vm.naviagteToShopTheLookPrd(cordinate.url)
          }
        }
      }, [_c('a', {
        staticClass: "green-dot-link",
        attrs: {
          "href": ((cordinate.url) + "?gte=" + (_vm.product.gender_type || 0)),
          "target": "_blank",
          "rel": "noopener noreferrer"
        }
      })])
    })) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "line2title mdproduct forTabAndMobile",
    class: _vm.productSlug === 'justice-league-reversible-hoodie' && 'prelative',
    staticStyle: {
      "padding": "0px",
      "border": "none"
    }
  }, [(_vm.showCountDown) ? _c('Countdown', {
    attrs: {
      "starttime": _vm.startDate,
      "mobileUI": _vm.$parent.isDesktop ? false : true,
      "isMobilePdp": _vm.$parent.isDesktop ? false : true,
      "endtime": _vm.endDate,
      "color": _vm.timerColor,
      "showTimer": _vm.showTimer,
      "pretext": _vm.liveSaleText,
      "showEarlyText": _vm.showEarlyText
    },
    on: {
      "getLiveSaleText": _vm.getSaleTextToShow
    }
  }) : _vm._e(), _vm._v(" "), _c('carousel', {
    ref: "my-carousel",
    staticClass: "pview",
    attrs: {
      "perPage": 1,
      "navigationEnabled": true,
      "paginationEnabled": true,
      "navigationNextLabel": "",
      "paginationPadding": 2,
      "paginationSize": 7,
      "paginationPosition": 'bottom',
      "navigationPrevLabel": "",
      "autoplay": false,
      "minSwipeDistance": 1,
      "speed": 200,
      "id": "pview"
    }
  }, _vm._l((_vm.product.images), function(pr, index) {
    return _c('slide', {
      key: index,
      staticClass: "slider-1"
    }, [(!_vm.$parent.isDesktop && _vm.product.video_url && _vm.product.show_video_url === 1 && (index === _vm.product.video_url_index)) ? _c('div', {
      staticStyle: {
        "height": "100%",
        "width": "100%"
      }
    }, [_c('VideoPlayer', {
      attrs: {
        "src": _vm.product.video_url,
        "poster": pr,
        "playVideo": _vm.bannerPlaceHolderForVideoAutoplay
      }
    }), _vm._v(" "), (_vm.bannerPlaceHolderForPdpTicker && _vm.product.tickers && _vm.product.tickers.length > 0 && _vm.currentTickerText) ? _c('div', {
      staticClass: "pdp-ticker"
    }, [_c('span', [_vm._v(_vm._s(_vm.currentTickerText))])]) : _vm._e()], 1) : _c('div', [_c('div', {
      directives: [{
        name: "lazyloadImage",
        rawName: "v-lazyloadImage"
      }],
      class: _vm.showBlur ? 'imgLink customFade' : _vm.productSlug === 'justice-league-reversible-hoodie' && 'show-views',
      staticStyle: {
        "height": "auto",
        "min-height": "450px",
        "max-height": "580px",
        "background": "rgb(255, 235, 231)"
      },
      style: (_vm.showBlur ? 'filter: blur(3px)' : null)
    }, [_c('img', {
      directives: [{
        name: "imageBackground",
        rawName: "v-imageBackground",
        value: ('1080:1440'),
        expression: "'1080:1440'"
      }],
      ref: "image",
      refInFor: true,
      staticClass: "pointer pimg img-auto",
      class: [{
        'customFade': !_vm.showBlur
      }, {
        'show-blur': _vm.product.is_blur
      }],
      attrs: {
        "data-url": _vm.prdImg + pr,
        "alt": _vm.altTagDisplay(index, _vm.product.product, _vm.product.category),
        "title": ("" + (_vm.altPrefix[index]) + (_vm.product.product) + " " + (_vm.product.category) + " Online at The Souled Store"),
        "width": "295",
        "height": "393"
      },
      on: {
        "click": function($event) {
          _vm.magnify(_vm.prdImg + pr, index)
        },
        "load": function($event) {
          _vm.updateDotPosition(index)
        }
      }
    }), _vm._v(" "), (_vm.showShopTheLook && _vm.product.image_coordinates && _vm.product.image_coordinates[_vm.modifyName(pr)] && _vm.product.image_coordinates[_vm.modifyName(pr)].length && _vm.isActiveSlide(index)) ? _c('div', _vm._l((_vm.product.image_coordinates[_vm.modifyName(pr)]), function(cordinate, cordinateIndex) {
      return _c('div', {
        key: cordinateIndex,
        staticClass: "green-dot",
        style: (_vm.getDotPosition(index, cordinate.x, cordinate.y)),
        on: {
          "click": function($event) {
            _vm.naviagteToShopTheLookPrd(cordinate.url)
          }
        }
      }, [_c('a', {
        staticClass: "green-dot-link",
        attrs: {
          "href": ((cordinate.url) + "?gte=" + (_vm.product.gender_type || 0)),
          "target": "_blank",
          "rel": "noopener noreferrer"
        }
      })])
    })) : _vm._e(), _vm._v(" "), (_vm.isOutOfStock) ? _c('div', {
      staticClass: "souled-out"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v("Souled Out")])]) : (_vm.isSouledOut && ['harry-potter-hufflepuff-sigil-scarf'].includes(_vm.productSlug)) ? _c('div', {
      staticClass: "coming-soon"
    }, [_vm._v("coming soon")]) : (_vm.isSouledOut) ? _c('div', {
      staticClass: "souledout"
    }) : _vm._e(), _vm._v(" "), (index === 0 && _vm.mockUpTag && Object.keys(_vm.mockUpTag).length) ? _c('div', {
      staticClass: "mockup-tag",
      class: _vm.getMockUpTagPositionClass(_vm.mockUpTag.tag_position)
    }, [_c('span', {
      style: ({
        backgroundColor: _vm.mockUpTag.background_color,
        color: _vm.mockUpTag.text_color
      })
    }, [_vm._v("\n                              " + _vm._s(_vm.mockUpTag.tag_name) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForPdpTicker && _vm.product.tickers && _vm.product.tickers.length > 0 && _vm.currentTickerText) ? _c('div', {
      staticClass: "pdp-ticker"
    }, [_c('span', [_vm._v(_vm._s(_vm.currentTickerText))])]) : _vm._e(), _vm._v(" "), (_vm.mockUpLabel && Object.keys(_vm.mockUpLabel).length && _vm.isLabelLieInTime) ? _c('div', {
      staticClass: "d-flex align-items-center label-container prelative"
    }, [_c('i', {
      staticClass: "fa fa-bolt pabsolute",
      style: ({
        borderColor: _vm.mockUpLabel.label.label_background_color
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "fbold ecltext",
      style: ({
        backgroundColor: _vm.mockUpLabel.label.label_background_color,
        color: _vm.mockUpLabel.label.label_text_color
      })
    }, [_vm._v(_vm._s(_vm.mockUpLabel.label.label_name))])]) : _vm._e()]), _vm._v(" "), (new Date(_vm.endDate) > new Date(_vm.now) && _vm.checkDailyDropObjectExist) ? _c('div', {
      staticClass: "image-wrapper__product-status"
    }, [_c('p', [_vm._v(_vm._s(_vm.liveSaleText))]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "background-color": "#fff",
        "margin": "7px 0"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.productLiveDate.date)), _c('sup', [_vm._v(_vm._s(_vm.productLiveDate.dateSup))]), _vm._v(" " + _vm._s(_vm.productLiveDate.month && _vm.productLiveDate.month.toUpperCase()) + " " + _vm._s(_vm.productLiveDate.time && _vm.productLiveDate.time.toUpperCase()))])]) : _vm._e()])])
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.isNewDesign) ? _c('div', {
    attrs: {
      "id": "scroll-till-that"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: !_vm.isNewDesign ? 'col-md-5 pr0' : ''
  }, [_c('div', {
    class: !_vm.isNewDesign ? 'productinfo px-3' : ''
  }, [_c('div', {
    staticClass: "price-box-container",
    class: {
      'newdesign-pricebox-fixed': _vm.isNewDesign && _vm.hasScrolledClass,
      'newdesign-pricebox': _vm.isNewDesign && _vm.isPriceSectionFixed
    }
  }, [_c('div', {
    staticClass: "bx1"
  }, [_c('div', {
    staticClass: "row mr0"
  }, [_c('div', {
    class: _vm.$parent.isDesktop ? 'col-12' : 'col-10'
  }, [_c('h1', {
    staticClass: "fbold mb-0 title-size",
    class: _vm.isNewDesign ? 'new-design-title' : ''
  }, [_vm._v(_vm._s(_vm.product.product))])]), _vm._v(" "), (!_vm.$parent.isDesktop && !_vm.isNewDesign) ? _c('div', {
    staticClass: "col-2 shareIcon",
    on: {
      "click": _vm.shareNavigatorHandler
    }
  }, [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                      SHARE\n                    ")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "mb0"
  }, [_c('router-link', {
    staticClass: "op_5",
    attrs: {
      "to": '/explore/' + _vm.product.category_slug
    }
  }, [_c('h1', {
    staticClass: "prod-cat"
  }, [_vm._v(_vm._s(_vm.product.category))])]), _vm._v(" "), _vm._l((_vm.product.cat), function(phoneCat) {
    return _c('span', {
      key: phoneCat
    }, [_c('u', [(phoneCat === 153) ? _c('router-link', {
      attrs: {
        "to": "/mobile-covers"
      }
    }, [_vm._v("(Change phone model)")]) : _vm._e()], 1)])
  })], 2), _vm._v(" "), (_vm.bannerPDPRating && (this.product.avg_rating >= 1)) ? _c('div', {
    staticClass: "ratingPDP"
  }, [_c('div', [_vm._v(_vm._s(this.product.avg_rating))]), _vm._v(" "), _c('img', {
    staticClass: "starRating",
    attrs: {
      "src": "https://w7.pngwing.com/pngs/566/674/png-transparent-green-star-blue-angle-leaf-thumbnail.png",
      "alt": "starImage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pipPDP"
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticClass: "pdpr"
  }, [_vm._v(_vm._s(_vm.getDataValue(this.product.rating_count)))])]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForArtistNameDisplay) ? _c('div', {
    staticClass: "prelative"
  }, [(_vm.product.added_by == 75692) ? _c('a', {
    attrs: {
      "href": "https://www.thesouledstore.com",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("By "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedArtist)
    }
  })]) : (_vm.product.firstname !== '') ? _c('router-link', {
    attrs: {
      "to": '/artists/' + _vm.product.artist_slug
    }
  }, [(_vm.formattedArtist) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(("By " + _vm.formattedArtist))
    },
    on: {
      "click": function($event) {
        _vm.artistEventHandler(_vm.formattedArtist, _vm.product)
      }
    }
  }) : _vm._e()]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.product.variant) ? _c('div', [(_vm.product.stock <= 0) ? _c('div', [_c('size-hover', {
    attrs: {
      "parentid": _vm.product.id,
      "proType": _vm.product.prod_type,
      "isOptions": false,
      "platform": _vm.product.platform || ''
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$parent.isDesktop) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "price-box-wrapper",
    class: !_vm.bannerPlaceHolderForGstInclusiveLabel ? 'mb20' : ''
  }, [(_vm.product.price) ? _c('span', {
    staticClass: "leftPrice pull-right"
  }, [(Math.round(_vm.product.spl_price) || (_vm.isExclusive && Math.round(_vm.product.exclusive_price))) ? _c('span', [(_vm.isExclusive && _vm.showMemberExclusivePrice) ? _c('span', {
    staticClass: "membership-product-price",
    staticStyle: {
      "font-size": "1.2em",
      "color": "#121212"
    }
  }, [_c('span', [_vm._v("Membership Price")]), _vm._v(" "), _c('span', {
    staticClass: "fsemibold",
    staticStyle: {
      "color": "#121212"
    }
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s((_vm.product.exclusive_price && parseInt(_vm.product.exclusive_price) || 0)))])]) : _c('span', {
    staticClass: "offer",
    staticStyle: {
      "font-size": "1.6em",
      "-webkit-text-stroke": "0.35px #ffffff"
    }
  }, [_c('span', {
    staticClass: "irupee"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" " + _vm._s(_vm.product.spl_price && parseInt(_vm.product.spl_price)) + "\n                          ")]), _vm._v(" "), ((_vm.isExclusive ? (_vm.product && parseInt(_vm.product.exclusive_price)) : (_vm.product && parseInt(_vm.product.spl_price))) !== parseInt(_vm.product.price)) ? _c('span', {
    staticStyle: {
      "font-size": "1.1em",
      "text-decoration": "line-through",
      "color": "#CCCCCC"
    }
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(parseInt(_vm.product.price)))]) : _vm._e()]) : (['50000-points-offer', '25000-points-offer', '12000-points-offer'].includes(_vm.productSlug)) ? _c('span', {
    staticClass: "fbold",
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_c('span', {
    staticClass: "irupee"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" " + _vm._s(_vm.$parent.currencyFormate(parseInt(_vm.product.price))))]) : _c('span', {
    staticClass: "fbold",
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_c('span', {
    staticClass: "irupee"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" " + _vm._s(parseInt(_vm.product.price)) + "\n                        ")]), _vm._v(" "), (_vm.product && _vm.product.spl_price && !_vm.isExclusive) ? _c('span', {
    staticStyle: {
      "color": "#E66A51",
      "font-size": "1.1em"
    }
  }, [(_vm.isNonExclusiveSavingsInPercent) ? _c('span', [_vm._v(_vm._s(parseInt(((_vm.product && _vm.product.price) - (_vm.isExclusive ? (_vm.product && _vm.product.exclusive_price) : (_vm.product && _vm.product.spl_price))) / (_vm.product && _vm.product.price) * 100)) + "% " + _vm._s((_vm.nonMemberSavingsTxt && _vm.nonMemberSavingsTxt.tag_text) || 'OFF') + "\n                          ")]) : (parseInt(_vm.product.price) - parseInt((_vm.isExclusive ? (_vm.product && _vm.product.exclusive_price) : (_vm.product && _vm.product.spl_price)))) ? _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(parseInt(_vm.product.price) - parseInt((_vm.isExclusive ? (_vm.product && _vm.product.exclusive_price) : (_vm.product && _vm.product.spl_price)))) + " " + _vm._s((_vm.nonMemberSavingsTxt && _vm.nonMemberSavingsTxt.tag_text) || 'OFF'))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.product && _vm.product.price && _vm.product.exclusive_price && _vm.isExclusive && !_vm.showMemberExclusivePrice) ? _c('span', {
    staticStyle: {
      "color": "#E66A51",
      "font-size": "1.1em",
      "margin-left": "2px"
    }
  }, [(_vm.isExclusiveSavingsInPercent) ? _c('span', [_vm._v(_vm._s(parseInt(((_vm.product && _vm.product.price) - (_vm.product && _vm.product.exclusive_price)) / (_vm.product && _vm.product.price) * 100)) + "% " + _vm._s((_vm.memberSavingsTxt && _vm.memberSavingsTxt.tag_text) || 'Member Savings'))]) : _c('span', {
    staticClass: "no-wrap"
  }, [_vm._v(_vm._s((_vm.memberSavingsTxt && _vm.memberSavingsTxt.tag_text) || 'Member Savings') + " " + _vm._s(_vm.currencySymbol) + " " + _vm._s(parseInt(_vm.product.price) - parseInt(_vm.product.exclusive_price)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [(_vm.product && _vm.product.mrp && parseInt(_vm.product.mrp) > 0 && _vm.showMrpOnPdp && _vm.isSelectedCountryIndia) ? _c('span', {
    staticClass: "mrp-slogan"
  }, [_vm._v("MRP Rs. " + _vm._s(parseInt(_vm.product.mrp)) + " " + _vm._s(_vm.showMrpOnPdp.tag_text))]) : (_vm.showPriceInclusiveOnPdp && !_vm.showMrpOnPdp && _vm.isSelectedCountryIndia) ? _c('span', {
    staticClass: "mrp-slogan"
  }, [_vm._v(_vm._s(_vm.showPriceInclusiveOnPdp.tag_text))]) : (_vm.showMrpOnPdpGlobal && !_vm.showMrpOnPdp && !_vm.isSelectedCountryIndia) ? _c('span', {
    staticClass: "mrp-slogan"
  }, [_vm._v(_vm._s(_vm.showMrpOnPdpGlobal.tag_text))]) : _vm._e()]), _vm._v(" "), (_vm.product && _vm.product.price && _vm.product.exclusive_price && !_vm.isExclusive && !_vm.$parent.isDesktop && _vm.bannerPlaceHolderForMemberShipBanner && _vm.isSelectedCountryIndia) ? _c('span', {
    staticClass: "membership-product-price",
    staticStyle: {
      "font-size": "1.2em",
      "color": "#121212"
    },
    on: {
      "click": _vm.openMembershipPopup
    }
  }, [_c('span', {
    staticClass: "membership-nonmember-info"
  }, [_vm._v("Get for")]), _vm._v(" "), _c('span', {
    staticClass: "membership-product-price-nonmember",
    staticStyle: {
      "color": "#121212"
    }
  }, [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s((_vm.product.exclusive_price && parseInt(_vm.product.exclusive_price) || 0)))]), _vm._v(" "), _c('span', [_c('img', {
    staticClass: "info-icon",
    attrs: {
      "src": "https://tss-static-images.gumlet.io/Vector.png",
      "alt": "vector.png"
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.product && _vm.product.price && _vm.product.exclusive_price && !_vm.isExclusive && _vm.showNonMemberExclusivePrice) ? _c('span', {
    staticClass: "non-membership-product-price",
    staticStyle: {
      "font-size": "1.2em",
      "color": "#121212"
    }
  }, [_c('span', [_vm._v("Get for")]), _vm._v(" "), _c('span', {
    staticClass: "fsemibold",
    staticStyle: {
      "color": "#121212"
    }
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s((_vm.product.exclusive_price && parseInt(_vm.product.exclusive_price) || 0)))]), _vm._v(" "), _c('span', [_vm._v("with membership")])]) : _vm._e(), _vm._v(" "), (_vm.isSelectedCountryIndia && _vm.bannerPlaceHolderForTSSpointsmodel && _vm.user && parseFloat(_vm.user.tss_points) > 0 && parseFloat(_vm.bannerPlaceHolderForTSSpointsmodel.description) <= parseFloat(_vm.user.tss_points) && _vm.tssPoint && !(_vm.tssPoint.price_after_tss_point_redemption === '' || _vm.tssPoint.price_after_tss_point_redemption === null || _vm.tssPoint.price_after_tss_point_redemption === undefined)) ? _c('div', {
    staticStyle: {
      "margin-bottom": "18px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-flex",
      "align-items": "center",
      "background-color": "#F0F0F0",
      "padding": "8px 12px",
      "border-radius": "8px",
      "font-family": "'Segoe UI', sans-serif",
      "font-size": "14px",
      "color": "#333"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "14px",
      "height": "14px",
      "cursor": "pointer",
      "margin-right": "8px"
    },
    attrs: {
      "src": "https://tss-static-images.gumlet.io/icons/tssHelpDetails.png",
      "alt": "More Info"
    },
    on: {
      "click": _vm.setTSSPointsData
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_c('strong', [_vm._v("Get this for")]), _vm._v(" "), _c('span', {
    staticClass: "irupee"
  }, [_c('strong', {
    staticStyle: {
      "color": "#148c8d"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.currencySymbol + _vm.roundedPriceAfterRedemption) + "\n                    ")])]), _vm._v(" "), _c('strong', [_vm._v("using your TSS points.")])])])]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderSnapmintSection && _vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "snapmint-wrapper"
  }, [_c('div', {
    staticClass: "snap_emi_txt",
    class: {
      mt20: _vm.product && _vm.product.price && _vm.product.exclusive_price && !_vm.isExclusive && _vm.showNonMemberExclusivePrice
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "snapmint_lowest_emi_value",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data-snapmint-price": _vm.getMerchantPrice * _vm.formData.quantity,
      "data-snapmint-merchant_id": _vm.merchantId,
      "data-snapmint-page": "products_page"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.bannerPlaceHolderForGstInclusiveLabel) ? _c('div', {
    staticClass: "gstInclusiveLabel mb-1"
  }, [_c('span', {
    style: (("color: " + (_vm.bannerPlaceHolderForGstInclusiveLabel.banner_text_color) + "; background: " + (_vm.bannerPlaceHolderForGstInclusiveLabel.banner_color) + ";"))
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderForGstInclusiveLabel.tag_text))])]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderPDPExclusivePrice && !_vm.isExclusive && _vm.product.show_exclusive_message) ? _c('div', {
    staticClass: "exclusivePrice mb20",
    style: (_vm.bannerPlaceHolderPDPExclusivePrice.styles)
  }, [_c('p', [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('span', {
    staticClass: "irupee"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" " + _vm._s(_vm.product.exclusive_price) + " " + _vm._s(_vm.bannerPlaceHolderPDPExclusivePrice.text))]), _vm._v(" "), _c('span', {
    staticClass: "knowLink",
    on: {
      "click": function($event) {
        _vm.knowPrice()
      }
    }
  }, [_vm._v("KNOW MORE?")])])]) : _vm._e(), _vm._v(" "), (_vm.product.is_printable) ? _c('div', {
    staticClass: "customization-wrapper mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center customized-input"
  }, [_c('span', {
    staticClass: "customcheckbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "av",
      "id": "accept"
    },
    domProps: {
      "checked": _vm.isCustomizedProdModal || _vm.isCustomizedProd
    },
    on: {
      "change": function($event) {
        _vm.handleCustomization($event.target.checked)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0",
    attrs: {
      "for": "accept"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('span', {
    staticClass: "customise-heading pointer",
    on: {
      "click": function($event) {
        _vm.handleCustomization(!(_vm.isCustomizedProdModal || _vm.isCustomizedProd))
      }
    }
  }, [_vm._v("Customise This " + _vm._s(_vm.customisableProductText))]), _vm._v(" "), _c('span', {
    staticClass: "darkblcolor fbold customise-price"
  }, [_vm._v(" (" + _vm._s(_vm.currencyRsToUSD) + " " + _vm._s(_vm.product.extra_price) + " extra)")])])]) : _vm._e(), _vm._v(" "), (_vm.product.prod_type === 6 && _vm.product.options.length) ? _c('div', {
    staticClass: "combo-products-wrapper"
  }, _vm._l((_vm.product.options), function(op, index) {
    return _c('div', {
      key: op.option_id,
      staticClass: "combo-product-wrapper",
      class: {
        'combo-border-b': index !== _vm.product.options.length - 1
      }
    }, [_c('div', {
      staticClass: "d-flex combo-prod-name-wrapper mb10"
    }, [_c('p', {
      staticClass: "bundleProName"
    }, [_vm._v(_vm._s(op.option_name))])]), _vm._v(" "), _c('div', {
      staticClass: "row margin-unset"
    }, [_c('select', {
      staticClass: "bundle-dropdown fregular col-md-5 col-12",
      domProps: {
        "value": _vm.selectedComboVariants[op.option_id] ? _vm.selectedComboVariants[op.option_id]['sku'] : ''
      },
      on: {
        "input": function($event) {
          _vm.handleVarientChange($event, op, index)
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "value": ""
      }
    }, [_vm._v("-- Please Select Product --")]), _vm._v(" "), _vm._l((op.variants), function(varnt) {
      return _c('option', {
        key: varnt.variant_id,
        attrs: {
          "disabled": !varnt.stock
        },
        domProps: {
          "value": varnt.sku
        }
      }, [_vm._v(_vm._s(varnt.name))])
    })], 2)]), _vm._v(" "), (!_vm.product.is_common_sizeChart_applicable && _vm.specificComboVarArr[index] && Object.keys(_vm.specificComboVarArr[index]).length) ? _c('div', {
      staticClass: "specific-combo-size pt-3"
    }, [_c('p', {
      staticClass: "select-size"
    }, [_c('span', {
      staticClass: "f16 font-weight-bold"
    }, [_vm._v("Please select  " + _vm._s(_vm.product.platform === 'KIDS' ? 'an age' : 'a size') + ".  ")]), _vm._v(" "), _c('span', {
      staticClass: "selectcolor pointer text-uppercase font-weight-normal",
      on: {
        "click": function($event) {
          _vm.getSizeChartData(_vm.specificComboVarArr[index].product_slug, _vm.specificComboVarArr[index].category_id, _vm.specificComboVarArr[index].category, index)
        }
      }
    }, [_vm._v("Size Chart\n                    ")])]), _vm._v(" "), _c('div', [_c('ul', {
      staticClass: "sizelist"
    }, _vm._l(((_vm.specificComboVarArr[index] && _vm.specificComboVarArr[index].variant)), function(val, key, index2) {
      return _c('li', {
        key: index2,
        staticClass: "oval",
        class: {
          outstock: (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock,
          selectedSize: (val.id == _vm.specificComboFormData[index]),
          unselectedSize: (val.id != _vm.specificComboFormData[index])
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.specificComboFormData[index]),
          expression: "specificComboFormData[index]"
        }],
        staticStyle: {
          "z-index": "-1"
        },
        attrs: {
          "type": "radio",
          "name": "sub_prod",
          "id": (index + "_" + key),
          "disabled": (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock || _vm.isSouledOut
        },
        domProps: {
          "value": val.id,
          "checked": _vm._q(_vm.specificComboFormData[index], val.id)
        },
        on: {
          "click": function($event) {
            _vm.changevalue(val)
          },
          "__c": function($event) {
            var $$exp = _vm.specificComboFormData,
              $$idx = index;
            if (!Array.isArray($$exp)) {
              _vm.specificComboFormData[index] = val.id
            } else {
              $$exp.splice($$idx, 1, val.id)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        class: {
          'strikethrough': ((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock)
        },
        staticStyle: {
          "border-radius": "30px",
          "position": "static"
        },
        attrs: {
          "for": (index + "_" + key)
        }
      }, [((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock) ? _c('span', {}, [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))]) : _c('span', {
        staticClass: "sizetext"
      }, [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))])]), _vm._v(" "), (_vm.enableTotalStockLeft && (_vm.product.prod_type === 3 || _vm.specificComboVarArr[index]) && _vm.specificComboFormData[index] && val.id == _vm.specificComboFormData[index] && val.stock > 0 && val.stock < _vm.stockLeftLimit && _vm.product.artist_slug !== 'bhadipa') ? _c('section', {
        staticClass: "total-stock bx1 total-size-based-stock"
      }, [_vm._v("\n                          " + _vm._s(val.stock) + " Left\n                        ")]) : _vm._e()])
    })), _vm._v(" "), (_vm.specificComboVarArr[index] && _vm.specificComboVarArr[index].variant && _vm.specificComboVarArr[index].variant.filter(function (itm) { return itm.stock === 0; }).length) ? _c('div', {
      staticClass: "disableclick outOfStockBox"
    }, [_c('size-hover', {
      attrs: {
        "parentid": _vm.product.id,
        "proType": _vm.product.prod_type,
        "isOptions": true,
        "sizes": _vm.specificComboVarArr[index] ? [].concat( _vm.specificComboVarArr[index].variant ) : [].concat( _vm.product.variant ),
        "isSouledOut": _vm.isSouledOut,
        "platform": _vm.product.platform || ''
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.specificSizeError && _vm.specificSizeError[index] && !_vm.isComboBreaked && !_vm.isSpecificSizeError) ? _c('div', {
      staticClass: "alert alert-danger",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v("Please select " + _vm._s(_vm.product.platform === 'KIDS' ? ' an age' : 'a size') + ".")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isProductOutOfStock(op)) ? _c('div', {
      staticClass: "specific-combo-size pt-3"
    }, [_c('div', [_c('ul', {
      staticClass: "sizelist"
    }, _vm._l((_vm.outofStockFirstProductsize), function(val, key, index2) {
      return _c('li', {
        key: index2,
        staticClass: "oval",
        class: {
          outstock: true || _vm.isOutOfStock,
          selectedSize: false,
          unselectedSize: true
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.specificComboFormData[index]),
          expression: "specificComboFormData[index]"
        }],
        staticStyle: {
          "z-index": "-1"
        },
        attrs: {
          "type": "radio",
          "name": "sub_prod",
          "id": (index + "_" + key),
          "disabled": (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock
        },
        domProps: {
          "value": val.id,
          "checked": _vm._q(_vm.specificComboFormData[index], val.id)
        },
        on: {
          "__c": function($event) {
            var $$exp = _vm.specificComboFormData,
              $$idx = index;
            if (!Array.isArray($$exp)) {
              _vm.specificComboFormData[index] = val.id
            } else {
              $$exp.splice($$idx, 1, val.id)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        class: {
          'strikethrough': (true || _vm.isOutOfStock)
        },
        staticStyle: {
          "border-radius": "30px",
          "position": "static"
        },
        attrs: {
          "for": (index + "_" + key)
        }
      }, [(true || _vm.isOutOfStock) ? _c('span', {}, [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))]) : _vm._e()])])
    }))])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.isColorWebEnable && _vm.product && _vm.product.color_group_details && _vm.product.color_group_details.length && _vm.product.color_group_details.length > 0) ? _c('div', [(_vm.colorWebHeader) ? _c('p', {
    staticClass: "group-header"
  }, [_c('span', {
    staticClass: "f16 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.colorWebHeader.description) + " ")])]) : _vm._e(), _vm._v(" "), (!_vm.isColorImgWebEnable) ? _c('div', {
    staticClass: "d-flex color-list-container-old"
  }, _vm._l((_vm.product.color_group_details), function(val, colorDetailIndex) {
    return _c('div', {
      key: colorDetailIndex,
      staticClass: "color-parent",
      class: _vm.product.product_slug === val.url_key ? 'active' : ''
    }, [_c('div', {
      staticClass: "color-child",
      style: ({
        backgroundColor: val.color,
      }),
      on: {
        "click": function($event) {
          _vm.prodRedirection(val.url_key)
        }
      }
    })])
  })) : _c('div', {
    staticClass: "color-web-wrapper"
  }, [_c('carousel', {
    ref: "my-carousel",
    staticClass: "color-web-carousel",
    attrs: {
      "navigationEnabled": _vm.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": "",
      "paginationPadding": 2,
      "paginationPosition": 'bottom',
      "navigationPrevLabel": "",
      "autoplay": false,
      "minSwipeDistance": 1,
      "speed": 100,
      "scrollPerPage": true,
      "paginationSize": 7,
      "perPageCustom": [
        [292, 3],
        [350, 4],
        [450, 4.8],
        [600, 6],
        [768, 3],
        [900, 4],
        [1029, 4.8],
        [1200, 6],
        [1920, 6]
      ]
    }
  }, _vm._l((_vm.reorderedColorGroupDetails), function(val, colorDetailIndex) {
    return (val && (val.default_image || val.color)) ? _c('slide', {
      key: colorDetailIndex,
      staticClass: "color-parent",
      class: _vm.product.product_slug === val.url_key ? 'active' : ''
    }, [_c('div', {
      staticClass: "d-flex color-list-container"
    }, [_c('div', {
      staticClass: "color-parent new-img-pallet",
      class: _vm.product.product_slug === val.url_key ? 'active' : ''
    }, [_c('div', {
      staticClass: "color-child",
      style: ({
        backgroundColor: val.color
      }),
      on: {
        "click": function($event) {
          _vm.prodRedirection(val.url_key)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "lazyloadImage",
        rawName: "v-lazyloadImage"
      }],
      staticClass: "image-wrapper"
    }, [(val.prod_qty === 0) ? _c('div', {
      staticClass: "sold-out-text"
    }, [_vm._v(" Souled Out")]) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "pointer reecomended-img",
      attrs: {
        "data-url": _vm.prdImg + val.default_image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "hover-color-overlay",
      style: ({
        background: ("linear-gradient(to top, " + (val.color) + ", transparent)")
      })
    })])])])])]) : _vm._e()
  }))], 1)]) : _vm._e(), _vm._v(" "), (((_vm.product.variant && _vm.product.variant.length || (_vm.product.is_common_sizeChart_applicable && _vm.commonComboVariantsProd && Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd.variant && _vm.commonComboVariantsProd.variant.length)) &&
    (_vm.productSlug !== 'black-panther-proutility-backpack' || (_vm.productSlug === 'black-panther-proutility-backpack' && _vm.endDate != _vm.exclusiveDate && ((_vm.now >= _vm.exclusiveDate && _vm.isExclusive) || _vm.now > _vm.endDate))) &&
    (!['black-panther-proutility-backpack'].includes(_vm.productSlug) || (['black-panther-proutility-backpack'].includes(_vm.productSlug) && _vm.now >= _vm.endDate)) &&
    (_vm.productSlug !== 'avengers-varsity-jacket' || (_vm.productSlug === 'avengers-varsity-jacket' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'mumbai-indians-fan-rohit-45-jersey' || (_vm.productSlug === 'mumbai-indians-fan-rohit-45-jersey' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-captain-america-tshirt' || (_vm.productSlug === 'anniversary-collection-captain-america-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-spider-man-tshirt' || (_vm.productSlug === 'anniversary-collection-spider-man-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-black-panther-tshirt' || (_vm.productSlug === 'anniversary-collection-black-panther-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-hulk-tshirt' || (_vm.productSlug === 'anniversary-collection-hulk-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-thor-tshirt' || (_vm.productSlug === 'anniversary-collection-thor-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-iron-man-tshirt' || (_vm.productSlug === 'anniversary-collection-iron-man-tshirt' && _vm.now > _vm.endDate))
  )) ? _c('div', {
    staticClass: "bx1"
  }, [_c('div', {
    staticClass: "seperator mb-1 seperatorExtra",
    class: _vm.product.prod_type === 6 ? 'mt-3' : ''
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "select-size group-header"
  }, [_c('span', {
    staticClass: "f16 font-weight-bold"
  }, [_vm._v("Please select " + _vm._s(_vm.product.platform === 'KIDS' ? 'an age' : 'a size') + ".  ")]), _vm._v(" "), _c('span', {
    staticClass: "selectcolor pointer text-uppercase font-weight-normal",
    on: {
      "click": function($event) {
        Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd ? _vm.getSizeChartData(_vm.commonComboVariantsProd.product_slug, _vm.commonComboVariantsProd.category_id, _vm.commonComboVariantsProd.category, null) : _vm.getSizeChartData(_vm.product.product_slug, _vm.product.category_id, _vm.product.category, null)
      }
    }
  }, [_vm._v("Size Chart\n                      ")])]), _vm._v(" "), (_vm.product.prod_type == 3 && _vm.productWiseSizeChartData && _vm.getVarientSizeDetails) ? _c('div', {
    staticClass: "size-data-details font-weight-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.getVarientSizeDetails)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.prod_type == 3 || Object.keys(_vm.commonComboVariantsProd).length) ? _c('div', [_c('ul', {
    staticClass: "sizelist"
  }, _vm._l((Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd ? _vm.commonComboVariantsProd.variant : _vm.product.variant), function(val, key, index) {
    return _c('li', {
      key: index,
      staticClass: "oval",
      class: {
        outstock: (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock,
        selectedSize: (val.id == _vm.selectedProductVariant.id),
        unselectedSize: (val.id != _vm.selectedProductVariant.id)
      },
      on: {
        "click": function($event) {
          _vm.changevalue(val)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formData.prod_id),
        expression: "formData.prod_id"
      }],
      staticStyle: {
        "z-index": "-1"
      },
      attrs: {
        "type": "radio",
        "name": "sub_prod",
        "id": key,
        "disabled": (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock
      },
      domProps: {
        "value": val.id,
        "checked": _vm._q(_vm.formData.prod_id, val.id)
      },
      on: {
        "__c": function($event) {
          _vm.formData.prod_id = val.id
        }
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'strikethrough': ((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock)
      },
      staticStyle: {
        "border-radius": "30px",
        "position": "static"
      },
      attrs: {
        "for": key
      }
    }, [((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock) ? _c('span', {}, [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))]) : _c('span', {
      staticClass: "sizetext"
    }, [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))])]), _vm._v(" "), (_vm.enableTotalStockLeft && (_vm.product.prod_type === 3 || _vm.commonComboVariantsProd) && _vm.selectedProductVariant && val.id == _vm.selectedProductVariant.id && val.stock > 0 && val.stock < _vm.stockLeftLimit && _vm.product.artist_slug !== 'bhadipa') ? _c('section', {
      staticClass: "total-stock bx1 total-size-based-stock"
    }, [_vm._v("\n                              " + _vm._s(val.stock) + " Left\n                            ")]) : _vm._e()])
  })), _vm._v(" "), (_vm.isSizeOutOfStock || _vm.isSouledOut || _vm.isOutOfStock) ? _c('div', {
    staticClass: "disableclick outOfStockBox"
  }, [_c('size-hover', {
    attrs: {
      "parentid": _vm.product.id,
      "proType": _vm.product.prod_type,
      "isOptions": true,
      "sizes": Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd ? [].concat( _vm.commonComboVariantsProd.variant ) : [].concat( _vm.product.variant ),
      "isSouledOut": _vm.isSouledOut,
      "platform": _vm.product.platform || ''
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.sizeError) ? _c('div', {
    staticClass: "alert alert-danger",
    class: _vm.isNewDesign ? 'new-design-size-error' : '',
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Please select " + _vm._s(_vm.product.platform === 'KIDS' ? 'an age' : 'a size') + ".")]) : _vm._e()])], 1), _vm._v(" "), (_vm.product.prod_type !== 6) ? _c('div', {
    staticClass: "seperator mt-1 seperatorExtra"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.product.prod_type === 3 && _vm.product.prod_qty && _vm.product.prod_qty < _vm.stockLeftLimit && (![149, 598].includes(_vm.product.category_id) || ([149, 598].includes(_vm.product.category_id) && (_vm.now < '2019-12-27 00:00:00' || _vm.now > '2019-12-27 01:59:59')))) ? _c('section', {
    staticClass: "total-stock bx1"
  }, [(!(_vm.selectedProductVariant && _vm.selectedProductVariant.stock)) ? _c('span', [_vm._v("\n                Total " + _vm._s(_vm.product.prod_qty) + " Left\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/product/bhadipa-varta-laugh-ticket') ? _c('section', {
    staticClass: "total-stock bx1"
  }, [_vm._v("\n                Total " + _vm._s(_vm.product.stock) + " Left\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isSouledOut && !_vm.isOutOfStock && _vm.$parent.isDesktop &&
    (_vm.productSlug !== 'black-panther-proutility-backpack' || (_vm.productSlug === 'black-panther-proutility-backpack' && _vm.endDate != _vm.exclusiveDate && ((_vm.now >= _vm.exclusiveDate && _vm.isExclusive) || _vm.now > _vm.endDate))) &&
    (_vm.productSlug !== 'camouflage-olive-hoodie' || (_vm.productSlug === 'camouflage-olive-hoodie' && _vm.now >= _vm.endDate && _vm.isExclusive)) &&
    (!['black-panther-proutility-backpack'].includes(_vm.productSlug) || (['black-panther-proutility-backpack'].includes(_vm.productSlug) && _vm.now >= _vm.endDate)) &&
    (_vm.productSlug !== 'avengers-varsity-jacket' || (_vm.productSlug === 'avengers-varsity-jacket' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'mumbai-indians-fan-rohit-45-jersey' || (_vm.productSlug === 'mumbai-indians-fan-rohit-45-jersey' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-captain-america-tshirt' || (_vm.productSlug === 'anniversary-collection-captain-america-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-spider-man-tshirt' || (_vm.productSlug === 'anniversary-collection-spider-man-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-black-panther-tshirt' || (_vm.productSlug === 'anniversary-collection-black-panther-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-hulk-tshirt' || (_vm.productSlug === 'anniversary-collection-hulk-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-thor-tshirt' || (_vm.productSlug === 'anniversary-collection-thor-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-iron-man-tshirt' || (_vm.productSlug === 'anniversary-collection-iron-man-tshirt' && _vm.now > _vm.endDate))) ? _c('div', {
    staticClass: "bx1 mb-1"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [(!_vm.isTssCorpProduct) ? _c('div', {
    staticClass: "CartsetQty mr20"
  }, [_c('div', {
    staticClass: "fltdiv lh28"
  }, [_vm._v("Quantity    ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.quantity),
      expression: "formData.quantity"
    }],
    staticClass: "qtyOption",
    attrs: {
      "disabled": _vm.product.is_mystery_product === 1
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.formData.quantity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changevalue(null, _vm.formData.quantity)
      }]
    }
  }, _vm._l((10), function(no) {
    return _c('option', {
      key: no,
      domProps: {
        "value": no
      }
    }, [_vm._v(_vm._s(no < 10 ? '0' + no : no))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.$parent.isDesktop && _vm.mockUpLabel && Object.keys(_vm.mockUpLabel).length && _vm.isLabelLieInTime) ? _c('div', {
    staticClass: "d-flex align-items-center label-container prelative"
  }, [_c('i', {
    staticClass: "fa fa-bolt pabsolute",
    style: ({
      borderColor: _vm.mockUpLabel.label.label_background_color
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "fbold ecltext",
    style: ({
      backgroundColor: _vm.mockUpLabel.label.label_background_color,
      color: _vm.mockUpLabel.label.label_text_color
    })
  }, [_vm._v(_vm._s(_vm.mockUpLabel.label.label_name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.product && _vm.product.additional_note && _vm.showAdditionalNote) ? _c('div', {
    staticClass: "bx1 mb-3"
  }, [_c('span', {
    staticClass: "additional-note",
    style: ({
      color: _vm.showAdditionalNote && _vm.showAdditionalNote.description || '#292b2c',
    })
  }, [_vm._v(_vm._s(_vm.product.additional_note))])]) : _vm._e(), _vm._v(" "), ((_vm.product.variant && _vm.product.variant.length > 0 && _vm.colorOptions && _vm.colorOptions.length > 0)) ? _c('div', {
    staticClass: "bx1 prod-attr-wrapper-desktop"
  }, [_c('p', {
    staticClass: "select-color-header"
  }, [_vm._v("Select Colors")]), _vm._v(" "), (_vm.product.prod_type == 3) ? _c('div', {
    staticClass: "row"
  }, [_c('ul', {
    class: {
      fixedHeight: !_vm.showMoreColors,
      autoHeight: _vm.showMoreColors,
      'colorsList col-xs-12 col-md-10 col-xl-8': true
    }
  }, _vm._l((_vm.colorOptions), function(prod) {
    return _c('li', {
      key: prod.product_slug,
      style: ([_vm.currentRouteName === prod.product_slug ? (prod.is_multicolor ? {
        'border': '4px solid #ffffff',
        'box-shadow': [("0 0 0 3px " + (prod.product_color))],
        'background': [("linear-gradient( 90deg, " + (prod.product_color) + " 50%, " + (prod.product_color2) + " 50% )")]
      } : {
        'border': '4px solid #ffffff',
        'box-shadow': [("0 0 0 3px " + (prod.product_color))],
        background: prod.product_color
      }) : (prod.is_multicolor ? {
        'border': '2px solid #999696',
        'background': [("linear-gradient( 90deg, " + (prod.product_color) + " 50%, " + (prod.product_color2) + " 50% )")]
      } : {
        'border': '2px solid #999696',
        background: prod.product_color
      })]),
      attrs: {
        "title": prod.product_name
      },
      on: {
        "click": function($event) {
          _vm.changeColor(prod.product_slug)
        }
      }
    })
  })), _vm._v(" "), (_vm.showMoreColors && this.colorOptions.length > 7) ? _c('div', {
    staticClass: "color-size-wrapper less pointer",
    on: {
      "click": function($event) {
        _vm.showColor()
      }
    }
  }, [_c('u', [_vm._v("Less "), _c('i', {
    staticClass: "fa fa-caret-up"
  })])]) : (!_vm.showMoreColors && this.colorOptions.length > 7) ? _c('div', {
    staticClass: "color-size-wrapper more pointer",
    on: {
      "click": function($event) {
        _vm.showColor()
      }
    }
  }, [_c('u', [_vm._v("More "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.product.variant && _vm.product.variant.length > 0 && _vm.colorOptions && _vm.colorOptions.length > 0)) ? _c('div', {
    staticClass: "bx1 prod-attr-wrapper-mobile"
  }, [_c('p', {
    staticClass: "select-color-header"
  }, [_vm._v("Select Colors")]), _vm._v(" "), (_vm.product.prod_type == 3) ? _c('div', [_c('ul', {
    staticClass: "colorsListMob"
  }, _vm._l((_vm.colorOptions), function(prod) {
    return _c('li', {
      key: prod.product_slug,
      style: ([_vm.currentRouteName === prod.product_slug ? (prod.is_multicolor ? {
        'border': '4px solid #ffffff',
        'box-shadow': [("0 0 0 3px " + (prod.product_color))],
        'background': [("linear-gradient( 90deg, " + (prod.product_color) + " 50%, " + (prod.product_color2) + " 50% )")]
      } : {
        'border': '4px solid #ffffff',
        'box-shadow': [("0 0 0 3px " + (prod.product_color))],
        background: prod.product_color
      }) : (prod.is_multicolor ? {
        'border': '2px solid #999696',
        'background': [("linear-gradient( 90deg, " + (prod.product_color) + " 50%, " + (prod.product_color2) + " 50% )")]
      } : {
        'border': '2px solid #999696',
        background: prod.product_color
      })]),
      on: {
        "click": function($event) {
          _vm.changeColor(prod.product_slug)
        }
      }
    })
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bx1 brd0 mb_mbo",
    class: _vm.isNewDesign ? 'new-design-btn' : ''
  }, [(_vm.isBuyNowPopup) ? _c('BuyNowMobile', {
    attrs: {
      "closeBuyNow": _vm.hideBuyNowPopup
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForAddToCartSizePopup && !_vm.$parent.isDesktop && _vm.isSizePopupActive) ? _c('div', {
    staticClass: "movePopup"
  }, [_c('div', {
    staticClass: "movePopupModalOverlay",
    on: {
      "click": function($event) {
        _vm.isSizePopupActive = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "movePopup-wrapper py-1 px-3",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row-reverse pb-1 my-1",
    on: {
      "click": function($event) {
        _vm.isSizePopupActive = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (((_vm.product.variant && _vm.product.variant.length) || (_vm.commonComboVariantsProd && Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd.variant && _vm.commonComboVariantsProd.variant.length))) ? _c('div', {
    class: _vm.isSizeOutOfStock || _vm.isSouledOut || _vm.isOutOfStock ? '' : 'pb-2 mb-1'
  }, [_c('p', {
    staticClass: "select-size mb-1"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Please select " + _vm._s(_vm.product.platform === 'KIDS' ? 'an age' : 'a size') + ". ")]), _vm._v(" "), _c('span', {
    staticClass: "selectcolor text-uppercase pointer",
    on: {
      "click": function($event) {
        _vm.commonComboVariantsProd && Object.keys(_vm.commonComboVariantsProd).length ? _vm.getSizeChartData(_vm.commonComboVariantsProd.product_slug, _vm.commonComboVariantsProd.category_id, _vm.commonComboVariantsProd.category, null) : _vm.getSizeChartData(_vm.product.product_slug, _vm.product.category_id, _vm.product.category, null)
      }
    }
  }, [_vm._v("\n                        Size Chart\n                      ")])]), _vm._v(" "), (_vm.product.prod_type == 3 || _vm.commonComboVariantsProd) ? _c('div', [_c('ul', {
    staticClass: "sizelist"
  }, _vm._l(((Object.keys(_vm.commonComboVariantsProd).length && _vm.commonComboVariantsProd ? _vm.commonComboVariantsProd.variant : _vm.product.variant)), function(val, key, index) {
    return _c('li', {
      key: index,
      staticClass: "oval",
      class: {
        outstock: (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock,
        selectedSize: (val.id == _vm.selectedProductVariant.id),
        unselectedSize: (val.id != _vm.selectedProductVariant.id)
      }
    }, [_c('input', {
      staticStyle: {
        "z-index": "-1"
      },
      attrs: {
        "type": "radio",
        "name": "sub_prod",
        "id": key,
        "disabled": (val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock
      },
      domProps: {
        "value": val.id
      },
      on: {
        "change": function($event) {
          _vm.changevalue(val)
        }
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'strikethrough': ((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock)
      },
      staticStyle: {
        "border-radius": "30px",
        "position": "static"
      },
      attrs: {
        "for": key
      }
    }, [((val.stock <= 0 && _vm.product.jit_value != 'JIT') || _vm.isOutOfStock) ? _c('span', {}, [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))]) : _c('span', {
      staticClass: "sizetext"
    }, [_vm._v(_vm._s(_vm.getSizeAttribute(val.attributes).value))])]), _vm._v(" "), (_vm.enableTotalStockLeft && (_vm.product.prod_type === 3 || (_vm.commonComboVariantsProd && Object.keys(_vm.commonComboVariantsProd).length)) && _vm.selectedProductVariant && val.id == _vm.selectedProductVariant.id && val.stock > 0 && val.stock < _vm.stockLeftLimit && _vm.product.artist_slug !== 'bhadipa') ? _c('section', {
      staticClass: "total-stock bx1 total-size-based-stock"
    }, [_vm._v("\n                            " + _vm._s(val.stock) + " Left\n                          ")]) : _vm._e()])
  })), _vm._v(" "), (_vm.isSizeOutOfStock || _vm.isSouledOut || _vm.isOutOfStock) ? _c('div', {
    staticClass: "disableclick outOfStockBox"
  }, [_c('size-hover', {
    attrs: {
      "parentid": _vm.product.id,
      "proType": _vm.product.prod_type,
      "isOptions": true,
      "sizes": _vm.commonComboVariantsProd && Object.keys(_vm.commonComboVariantsProd).length ? [].concat( _vm.commonComboVariantsProd.variant ) : [].concat( _vm.product.variant ),
      "isSouledOut": _vm.isSouledOut,
      "isMoveToCartPopup": true,
      "platform": _vm.product.platform || ''
    }
  })], 1) : _vm._e()]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.authStatus && _vm.product && _vm.product.stock <= 0 && _vm.product.prod_qty <= 0 && _vm.getVoteCardDetails && _vm.getVotedProductText) ? _c('div', {
    class: _vm.$parent.isDesktop ? 'return-and-tss-message-box p-2 my-3' : 'my-1'
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.productVoted) ? _c('span', [_c('img', {
    staticClass: "tss-vote-icon",
    class: {
      'my-1': !_vm.$parent.isDesktop
    },
    attrs: {
      "src": "https://tss-static-images.gumlet.io/vote.png",
      "alt": "Vote image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pointer voteNowStyles pl-2",
    on: {
      "click": _vm.voteSoldedOutProduct
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.getVoteCardDetails.tag_text) + " ")]), _vm._v(" " + _vm._s(_vm.getVoteCardDetails.description) + "\n                  ")]) : _c('span', [_c('img', {
    staticClass: "tss-vote-icon",
    class: {
      'my-1': !_vm.$parent.isDesktop
    },
    attrs: {
      "src": "https://tss-static-images.gumlet.io/round_tick.png",
      "alt": "Voted image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("\n                      " + _vm._s(_vm.getVotedProductText.description) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "seperator seperatorExtra mt-1"
  })], 1) : _vm._e(), _vm._v(" "), ((!_vm.productZoomMobile) && (!_vm.isBuyNowPopup)) ? _c('div', {
    staticClass: "mbstickyfooter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.prod_id),
      expression: "formData.prod_id"
    }],
    attrs: {
      "type": "hidden",
      "name": "prod_id",
      "id": "prod_id"
    },
    domProps: {
      "value": (_vm.formData.prod_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.prod_id = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.prod_type),
      expression: "formData.prod_type"
    }],
    attrs: {
      "type": "hidden",
      "name": "prod_type",
      "value": "product.prod_type"
    },
    domProps: {
      "value": (_vm.formData.prod_type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.prod_type = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.exclusiveMembershipAdded) ? _c('div', {
    staticClass: "notification-message"
  }, [_vm._v("\n                  The Souled Store Membership has been added to cart.\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.enableActionBoton && _vm.isBlurProductClickablePdp && !_vm.isSouledOut && !_vm.$parent.isDesktop && _vm.isWishlist) ? _c('div', {
    class: !_vm.bannerPlaceHolderForBuyNow ? 'col-2' : 'col-5'
  }, [_c('button', {
    staticClass: "btn btn-lg btn-block pointer wishlistBtnMobile text-uppercase p-0",
    style: (!_vm.bannerPlaceHolderForBuyNow ? 'padding: 0;' : ''),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateWishlist(_vm.getWishistPrmData, $event)
      }
    }
  }, [_c('span', {
    staticClass: "wishlistIcon",
    class: _vm.product && _vm.wishlistItemsIDs && _vm.wishlistItemsIDs[_vm.product.id] ? 'wishlistActive' : 'wishlist',
    style: (!_vm.bannerPlaceHolderForBuyNow ? 'left: 25%;' : '')
  }), _vm._v(" "), (_vm.bannerPlaceHolderForBuyNow) ? _c('span', {
    staticClass: "wishlistText"
  }, [_vm._v("  wishlist")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col btnRow"
  }, [(_vm.goToCart || (_vm.product.prod_type === 6 && _vm.isComboProductAddedInCart) || (_vm.isTssCorpProduct && _vm.isTssCorporateProductAddedInCart)) ? _c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-block  pointer text-uppercase btnWidth",
    class: {
      'mr0': _vm.isTssCorpProduct || _vm.product.prod_type === 6
    },
    attrs: {
      "to": '/cart'
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToCartClick($event)
      }
    }
  }, [_vm._v("Go to cart\n                    ")]) : ((_vm.isSouledOut || _vm.isOutOfStock) && !_vm.isComboBreaked) ? _c('button', {
    staticClass: "btn btnWidth btn-lg btn-block pointer stockButton disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                      Out of Stock\n                    ")]) : (_vm.enableActionBoton && _vm.isBlurProductClickablePdp && !['camouflage-olive-hoodie', 'black-panther-proutility-backpack', 'black-panther-proutility-backpack', 'avengers-varsity-jacket', 'mumbai-indians-fan-rohit-45-jersey', 'anniversary-collection-captain-america-tshirt', 'anniversary-collection-spider-man-tshirt', 'anniversary-collection-black-panther-tshirt', 'anniversary-collection-hulk-tshirt', 'anniversary-collection-thor-tshirt', 'anniversary-collection-iron-man-tshirt'].includes(_vm.productSlug) || (_vm.productSlug === 'camouflage-olive-hoodie' && _vm.now >= _vm.endDate && _vm.isExclusive) ||
    (['black-panther-proutility-backpack'].includes(_vm.productSlug) && _vm.now >= _vm.endDate) ||
    (_vm.productSlug === 'black-panther-proutility-backpack' && _vm.endDate != _vm.exclusiveDate && ((_vm.now >= _vm.exclusiveDate && _vm.isExclusive) || _vm.now > _vm.endDate)) ||
    (_vm.productSlug === 'batman-3d-logo-tshirt' && _vm.endDate != _vm.exclusiveDate && ((_vm.now >= _vm.exclusiveDate && _vm.isExclusive) || _vm.now > _vm.endDate)) ||
    (_vm.productSlug === 'avengers-varsity-jacket' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'mumbai-indians-fan-rohit-45-jersey' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-captain-america-tshirt' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-spider-man-tshirt' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-black-panther-tshirt' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-hulk-tshirt' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-thor-tshirt' && _vm.now > _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-iron-man-tshirt' && _vm.now > _vm.endDate)
  ) ? _c('button', {
    staticClass: "btn btn-danger btnWidth btn-lg btn-block pointer",
    class: {
      'mr0': _vm.isTssCorpProduct || _vm.product.prod_type === 6
    },
    style: ([_vm.cartSaleStyle]),
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.isProductInLocalCart || _vm.isProductInLocalCartProperty || _vm.checkDisabled() || (this.product.prod_type === 6 && _vm.selectedComboVariants && Object.keys(_vm.selectedComboVariants).length <= 0)
    },
    on: {
      "click": function($event) {
        _vm.addToCart()
      }
    }
  }, [_vm._v("\n                             " + _vm._s(_vm.cartSaleStyle && _vm.cartSaleStyle.text ? _vm.cartSaleStyle.text : 'Add to cart') + "\n                      ")]) : (_vm.enableActionBoton && _vm.isBlurProductClickablePdp && (_vm.productSlug === 'camouflage-olive-hoodie' && (!_vm.isExclusive || (_vm.isExclusive && _vm.now < _vm.endDate))) ||
    (['black-panther-proutility-backpack'].includes(_vm.productSlug) && _vm.now < _vm.endDate) ||
    (_vm.productSlug === 'black-panther-proutility-backpack' && (_vm.now < _vm.exclusiveDate) || (_vm.now < _vm.endDate && _vm.endDate != _vm.exclusiveDate && !_vm.isExclusive)) ||
    (_vm.productSlug === 'batman-3d-logo-tshirt' && (_vm.now < _vm.exclusiveDate) || (_vm.now < _vm.endDate && _vm.endDate != _vm.exclusiveDate && !_vm.isExclusive)) ||
    (_vm.productSlug === 'avengers-varsity-jacket' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'mumbai-indians-fan-rohit-45-jersey' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-captain-america-tshirt' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-spider-man-tshirt' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-black-panther-tshirt' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-hulk-tshirt' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-thor-tshirt' && _vm.now <= _vm.endDate) ||
    (_vm.productSlug === 'anniversary-collection-iron-man-tshirt' && _vm.now <= _vm.endDate)
  ) ? _c('button', {
    staticClass: "btn btn-danger btnWidth btn-lg btn-block pointer",
    class: {
      'mr0': _vm.isTssCorpProduct || _vm.product.prod_type === 6
    },
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("Add to cart\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.enableActionBoton && _vm.isBlurProductClickablePdp && _vm.isWishlist) ? _c('button', {
    staticClass: "btn pointer wishList_Btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateWishlist(_vm.getWishistPrmData, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.wishlistItemsIDs && _vm.product && _vm.wishlistItemsIDs[_vm.product.id] ? 'fa-heart' : 'fa-heart-o',
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.product && _vm.wishlistItemsIDs && _vm.wishlistItemsIDs[_vm.product.id]) ? _c('span', [_vm._v("Added to Wishlist")]) : _c('span', [_vm._v("Add to Wishlist")])]) : _vm._e()], 1), _vm._v(" "), (_vm.enableActionBoton && _vm.isBlurProductClickablePdp && !_vm.isSouledOut && !_vm.$parent.isDesktop && !_vm.bannerPlaceHolderForBuyNow && _vm.product.prod_type !== 6 && !_vm.isTssCorpProduct) ? _c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-info btn-block pointer",
    staticStyle: {
      "border-radius": "3px",
      "background-color": "teal"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.buyNowHandler()
      }
    }
  }, [_vm._v("BUY NOW\n                    ")])]) : _vm._e()]), _vm._v(" "), (!_vm.enableActionBoton) ? _c('div', {
    staticClass: "membership_action_Btn"
  }, [(_vm.isWishlist) ? _c('button', {
    staticClass: "btn pointer membership_Btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.AddMembership()
      }
    }
  }, [_c('img', {
    staticClass: "ml-2",
    attrs: {
      "src": "https://tss-static-images.gumlet.io/Vector.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "membership_Btn_text"
  }, [_vm._v("Purchase membership to access")])]) : _vm._e()]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), (!_vm.isTssCorpProduct && _vm.$parent.isDesktop) ? _c('div', {
    staticClass: "bx1 brdnone"
  }, [(!_vm.isNewDesign) ? _c('div', {
    staticClass: "mb_mbo mb15"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Share ")]), _vm._v(" "), _c('div', {
    staticClass: "sharebtns f22",
    on: {
      "click": _vm.open
    }
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.tss + _vm.$route.path,
      "title": _vm.product.product
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(!_vm.$parent.isDesktop) ? _c('network', {
            staticClass: "showmobile disinline f24",
            attrs: {
              "network": "whatsapp",
              "id": "whatsapp"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-whatsapp"
          })]) : _vm._e(), _vm._v(" "), _c('a', {
            staticClass: "nonecolor showdesktoplinine",
            attrs: {
              "href": 'https://web.whatsapp.com/send?text=https://www.thesouledstore.com' + this.$route.fullPath,
              "rel": "noopener noreferrer",
              "target": "_blank",
              "id": "whatsapp"
            }
          }, [_c('span', {
            staticClass: "fa fa-whatsapp"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "facebook",
              "id": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-facebook-square"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter",
              "id": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-twitter"
          })]), _vm._v(" "), _c('a', {
            staticClass: "nonecolor",
            attrs: {
              "href": "https://www.instagram.com/TheSouledStore/",
              "target": "_blank",
              "rel": "noopener noreferrer",
              "id": "instagram"
            }
          }, [_c('span', {
            staticClass: "fa fa-instagram"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderTSSPoints && _vm.bannerPlaceHolderTSSPoints.tss_points && !(_vm.product.variant && _vm.product.variant.length > 0 &&
    (_vm.productSlug !== 'black-panther-proutility-backpack' || (_vm.productSlug === 'black-panther-proutility-backpack' && _vm.endDate != _vm.exclusiveDate && ((_vm.now >= _vm.exclusiveDate && _vm.isExclusive) || _vm.now > _vm.endDate))) &&
    (!['black-panther-proutility-backpack'].includes(_vm.productSlug) || (['black-panther-proutility-backpack'].includes(_vm.productSlug) && _vm.now >= _vm.endDate)) &&
    (_vm.productSlug !== 'avengers-varsity-jacket' || (_vm.productSlug === 'avengers-varsity-jacket' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'mumbai-indians-fan-rohit-45-jersey' || (_vm.productSlug === 'mumbai-indians-fan-rohit-45-jersey' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-captain-america-tshirt' || (_vm.productSlug === 'anniversary-collection-captain-america-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-spider-man-tshirt' || (_vm.productSlug === 'anniversary-collection-spider-man-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-black-panther-tshirt' || (_vm.productSlug === 'anniversary-collection-black-panther-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-hulk-tshirt' || (_vm.productSlug === 'anniversary-collection-hulk-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-thor-tshirt' || (_vm.productSlug === 'anniversary-collection-thor-tshirt' && _vm.now > _vm.endDate)) &&
    (_vm.productSlug !== 'anniversary-collection-iron-man-tshirt' || (_vm.productSlug === 'anniversary-collection-iron-man-tshirt' && _vm.now > _vm.endDate))
  )) ? _c('div', {
    staticClass: "seperator seperatorExtra"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.$parent.isDesktop ? 'return-and-tss-message-box my-3' : 'my-1'
  }, [(_vm.bannerPlaceHolderTSSPoints && _vm.bannerPlaceHolderTSSPoints.tss_points && _vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-12 return-msg-pdp tss-points-message-pdp d-flex justify-content-start align-items-center"
  }, [_c('img', {
    staticClass: "tss-points-icon",
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/public/theSoul/images/appIcons/ic_tssMoney1@3x.png",
      "alt": "The Souled Store Points"
    }
  }), _vm._v(" "), _c('p', {}, [_c('span', {
    style: ({
      color: _vm.bannerPlaceHolderTSSPoints.banner_text_color
    })
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderTSSPoints.prev_text))]), _vm._v(" "), _c('span', {
    staticClass: "tss-points"
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderTSSPoints.tss_points))]), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.bannerPlaceHolderTSSPoints.banner_text_color
    })
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderTSSPoints.after_text))])])])]) : _vm._e()]), _vm._v(" "), (_vm.bannerPlaceHolderTSSPoints && _vm.bannerPlaceHolderTSSPoints.tss_points) ? _c('div', {
    staticClass: "seperator mb-1 seperatorExtra"
  }) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForDeliveryDetails && !_vm.isSelectedCountryUAE) ? _c('div', {
    class: _vm.isNewDesign ? 'new-design-delivery' : ''
  }, [_c('p', {
    staticClass: "delivery-details-txt"
  }, [_vm._v("Delivery Details")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handlePinCodeChange($event)
      }
    }
  }, [_c('div', {
    staticClass: "pincode-input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pincode),
      expression: "pincode"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.isSelectedCountryIndia ? 'Enter Pincode' : 'Enter Zipcode',
      "minlength": _vm.isSelectedCountryUK ? 5 : _vm.pincodeLength,
      "maxlength": _vm.pincodeLength
    },
    domProps: {
      "value": (_vm.pincode)
    },
    on: {
      "keydown": function($event) {
        _vm.validatePinCode($event, _vm.pincodeLength, this.countryId)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pincode = $event.target.value
      }, _vm.handlePinCodeInputChange],
      "paste": _vm.handlePaste
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pincode-btn-wrapper"
  }, [_c('button', {
    staticClass: "btn-pincode",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.pincodeBtnType))])])])]), _vm._v(" "), (_vm.showSelectSizeValidationMsg) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("Please select " + _vm._s(_vm.product.platform === 'KIDS' ? 'an age' : 'a size'))]) : _vm._e(), _vm._v(" "), (_vm.showPincodeValidationMsg) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.validation.firstError('pincode')))]) : _vm._e(), _vm._v(" "), (_vm.deliveryDetails && _vm.deliveryDetails.success && _vm.deliveryDetails.data) ? _c('div', {
    staticClass: "mt15 delivery-details-content"
  }, [(!_vm.isTssCorpProduct) ? _c('div', {
    staticClass: "cod-message-text-wrapper"
  }, [_c('img', {
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/public/theSoul/images/icons/money-icon.png",
      "alt": "COD Details"
    }
  }), _vm._v(" "), (_vm.deliveryDetails.data.check_cod) ? _c('p', [_vm._v(_vm._s(_vm.bannerPlaceHolderForCODMessage && _vm.bannerPlaceHolderForCODMessage.tag_text))]) : _c('p', [_vm._v(_vm._s(_vm.bannerPlaceHolderForCODMessage && _vm.bannerPlaceHolderForCODMessage.description))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cod-message-text-wrapper"
  }, [_c('img', {
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/public/theSoul/images/icons/truck-icon.png",
      "alt": "Delivery Estimate"
    }
  }), _vm._v(" "), (_vm.deliveryDetails.data.serviceability && _vm.deliveryDetails.data.max_estimated_days_new) ? _c('p', [_vm._v("Estimated Delivery\n                    "), (_vm.estimatedDeliveryText) ? _c('span', [_vm._v("between " + _vm._s(_vm.getDeliveryDateRange) + ".")]) : _c('span', [_vm._v("by " + _vm._s(_vm.getDeliveryDate) + ".")])]) : _c('p', [_vm._v("Delivery is not serviceable at this Pincode")])])]) : (_vm.deliveryDetails && _vm.deliveryDetails.data && !_vm.deliveryDetails.success) ? _c('div', {
    staticClass: "mt10"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Delivery is not serviceable at this Pincode")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "return-and-tss-message-box my-3"
  }, [(_vm.product.exchange_return_message) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-12 return-msg-pdp"
  }, [_c('div', {
    staticClass: "d-flex justify-content-start align-items-start"
  }, [_c('img', {
    staticClass: "return-icon-pdp img-auto",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/return-icon.png",
      "width": "27",
      "height": "27",
      "alt": "Return Policy"
    }
  }), _vm._v(" "), _c('div', [(_vm.product.exchange_return_message && !_vm.product.exchange_return_message.toLowerCase().includes('know more')) ? _c('p', {
    staticClass: "mb-0",
    style: (_vm.showBoldReturnText && 'font-weight: bold')
  }, [_vm._v(_vm._s(_vm.product.exchange_return_message))]) : _c('p', {
    staticClass: "mb-0",
    style: (_vm.showBoldReturnText && 'font-weight: bold')
  }, _vm._l((_vm.productReturnMsgArr(_vm.product.exchange_return_message)), function(text, index) {
    return _c('span', {
      key: index
    }, [(text && text.toLowerCase() === 'know more') ? _c('span', {
      staticClass: "selectcolor pointer",
      class: !_vm.$parent.isDesktop ? 'dspBlock' : '',
      on: {
        "click": function($event) {
          _vm.returnPolicyKnowMore = !_vm.returnPolicyKnowMore
        }
      }
    }, [_vm._v(_vm._s(text))]) : _c('span', {
      domProps: {
        "innerHTML": _vm._s(text)
      }
    })])
  })), _vm._v(" "), (_vm.$parent.isDesktop && _vm.returnPolicyKnowMore && _vm.customisedProdFaqs && Object.keys(_vm.customisedProdFaqs).length) ? _c('div', {
    staticClass: "mt10"
  }, [_c('p', {
    staticClass: "fbold mb0"
  }, [_vm._v("FAQs")]), _vm._v(" "), _c('faqsQuestionsListing', {
    attrs: {
      "selectedFaq": _vm.customisedProdFaqs,
      "selectedFaqIndex": 1,
      "callerComp": "customised-prod-faqs"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (!_vm.$parent.isDesktop && _vm.returnPolicyKnowMore && _vm.customisedProdFaqs && Object.keys(_vm.customisedProdFaqs).length) ? _c('div', {
    staticClass: "mt10"
  }, [_c('p', {
    staticClass: "fbold mb0"
  }, [_vm._v("FAQs")]), _vm._v(" "), _c('faqsQuestionsListing', {
    attrs: {
      "selectedFaq": _vm.customisedProdFaqs,
      "selectedFaqIndex": 1,
      "callerComp": "customised-prod-faqs"
    }
  })], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.showTickerPoints && _vm.tickerPoint && _vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "ticker-point mt-3 d-flex justify-content-start align-items-center"
  }, [_c('img', {
    attrs: {
      "src": "https://tss-static-images.gumlet.io/gift-box.png",
      "alt": "wishlist",
      "width": "40",
      "height": "40"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ticker-text m-0 p-0",
    domProps: {
      "innerHTML": _vm._s(_vm.tickerPoint)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mtb15 w100 mr-0"
  }, [(_vm.isNewDesign && _vm.$parent.isDesktop) ? _c('div', {
    staticClass: "new-design-tabs"
  }, [_c('ul', {
    staticClass: "nav nav-pills",
    attrs: {
      "role": "tablist"
    }
  }, [(_vm.bannerPlaceHolderForCustomerReviews && _vm.product.category && (_vm.product.category === 'Women Pajamas' || _vm.product.category === 'Women Pajama Sets' || _vm.product.category === 'Women Pajama Set' || _vm.product.category.indexOf('Pocket Dresses') !== -1 || _vm.product.category === 'Women Bikini' || _vm.product.category === 'Women Boy Shorts' || _vm.product.category === 'Women Hipster Underwear')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-links",
    attrs: {
      "data-toggle": "pill",
      "href": "#tabs-1"
    }
  }, [_vm._v("Customer Reviews")])]) : _vm._e(), _vm._v(" "), (_vm.product.add_desc) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-links active",
    attrs: {
      "data-toggle": "pill",
      "href": "#tabs-2"
    }
  }, [_vm._v("Product Details")])]) : _vm._e(), _vm._v(" "), (_vm.product.short_desc) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-links",
    attrs: {
      "data-toggle": "pill",
      "href": "#tabs-3"
    }
  }, [_vm._v("Product Description")])]) : _vm._e(), _vm._v(" "), (_vm.product.user_description) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-links",
    attrs: {
      "data-toggle": "pill",
      "href": "#tabs-4"
    }
  }, [_vm._v("Artist's Details")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.bannerPlaceHolderForCustomerReviews && _vm.product.category && (_vm.product.category === 'Women Pajamas' || _vm.product.category === 'Women Pajama Sets' || _vm.product.category === 'Women Pajama Set' || _vm.product.category.indexOf('Pocket Dresses') !== -1 || _vm.product.category === 'Women Bikini' || _vm.product.category === 'Women Boy Shorts' || _vm.product.category === 'Women Hipster Underwear')) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "tabs-1"
    }
  }, [(_vm.productPerData && _vm.productPerData.length) ? _c('div', {
    staticClass: "card-block pg-block"
  }, _vm._l((_vm.productPerData), function(val, index) {
    return _c('div', {
      key: index
    }, [(_vm.product.category.indexOf(val.category) !== -1) ? _c('div', {
      staticClass: "pg-col"
    }, [_c('span', [_vm._v(_vm._s(val.title))]), _vm._v(" "), _c('div', {
      staticClass: "progress progress-danger active",
      attrs: {
        "aria-valuenow": "12"
      }
    }, [_c('div', {
      staticClass: "bar",
      style: ('width:' + val.percentage + '%')
    })]), _vm._v(" "), _c('span', {
      staticClass: "pull-right prg-text"
    }, [_vm._v(_vm._s(val.text) + " (" + _vm._s(val.percentage) + "%)")])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.reviewsData && _vm.reviewsData.length) ? _c('div', {
    staticClass: "scrolldiv"
  }, _vm._l((_vm.shuffle(_vm.reviewsData)), function(rew, index) {
    return _c('div', {
      key: index
    }, [(_vm.product.category.indexOf(rew.category) !== -1) ? _c('div', {
      staticClass: "cus-review"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(rew.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name-age"
    }, [_c('span', [_vm._v(_vm._s(rew.name))]), (rew.age) ? _c('span', [_vm._v(" | Age - " + _vm._s(rew.age) + " years")]) : _vm._e()])]) : _vm._e()])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.product.add_desc) ? _c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tabs-2"
    }
  }, [_c('div', {
    staticClass: "card-block clearfix"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.add_desc)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.product.short_desc) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "tabs-3"
    }
  }, [_c('div', {
    staticClass: "card-block clearfix"
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.short_desc)
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.product.user_description) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "tabs-4"
    }
  }, [_c('div', {
    staticClass: "card-block clearfix"
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.user_description)
    }
  })])])]) : _vm._e()])]) : _c('div', {
    staticClass: "accordiontabs",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [(_vm.bannerPlaceHolderForCustomerReviews && _vm.product.category && (_vm.product.category === 'Women Pajamas' || _vm.product.category === 'Women Pajama Sets' || _vm.product.category === 'Women Pajama Set' || _vm.product.category.indexOf('Pocket Dresses') !== -1 || _vm.product.category === 'Women Bikini' || _vm.product.category === 'Women Boy Shorts' || _vm.product.category === 'Women Hipster Underwear')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingThree"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheading"
  }, [_c('a', {
    staticClass: "collapsed cusrev",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    },
    on: {
      "click": _vm.productDescription
    }
  }, [_vm._v("\n                    Customer Reviews\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse show",
    attrs: {
      "id": "collapseThree",
      "role": "tabpanel",
      "aria-labelledby": "headingThree"
    }
  }, [(_vm.productPerData && _vm.productPerData.length) ? _c('div', {
    staticClass: "card-block pg-block"
  }, _vm._l((_vm.productPerData), function(val, index) {
    return _c('div', {
      key: index
    }, [(_vm.product.category.indexOf(val.category) !== -1) ? _c('div', {
      staticClass: "pg-col"
    }, [_c('span', [_vm._v(_vm._s(val.title))]), _vm._v(" "), _c('div', {
      staticClass: "progress progress-danger active",
      attrs: {
        "aria-valuenow": "12"
      }
    }, [_c('div', {
      staticClass: "bar",
      style: ('width:' + val.percentage + '%')
    })]), _vm._v(" "), _c('span', {
      staticClass: "pull-right prg-text"
    }, [_vm._v(_vm._s(val.text) + " (" + _vm._s(val.percentage) + "%)")])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.reviewsData && _vm.reviewsData.length) ? _c('div', {
    staticClass: "scrolldiv"
  }, _vm._l((_vm.shuffle(_vm.reviewsData)), function(rew, index) {
    return _c('div', {
      key: index
    }, [(_vm.product.category && _vm.product.category.indexOf(rew.category || '') !== -1) ? _c('div', {
      staticClass: "cus-review"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(rew.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name-age"
    }, [_c('span', [_vm._v(_vm._s(rew.name))]), (rew.age) ? _c('span', [_vm._v(" | Age - " + _vm._s(rew.age) + " years")]) : _vm._e()])]) : _vm._e()])
  })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.product.add_desc) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingOne"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheading"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseOne",
      "aria-expanded": _vm.bannerPlaceHolderForCustomerReviews && _vm.product.category && (_vm.product.category === 'Women Pajamas' || _vm.product.category === 'Women Pajama Sets' || _vm.product.category === 'Women Pajama Set' || _vm.product.category.indexOf('Pocket Dresses') !== -1 || _vm.product.category === 'Women Bikini' || _vm.product.category === 'Women Boys Shorts' || _vm.product.category === ' Women Hipster Underwear') ? 'false' : 'true',
      "aria-controls": "collapseOne"
    },
    on: {
      "click": _vm.productDetails
    }
  }, [_vm._v("\n                    Product Details\n                  ")])])]), _vm._v(" "), _c('div', {
    class: _vm.bannerPlaceHolderForCustomerReviews && _vm.product.category && (_vm.product.category === 'Women Pajamas' || _vm.product.category === 'Women Pajama Sets' || _vm.product.category === 'Women Pajama Set' || _vm.product.category.indexOf('Pocket Dresses') !== -1 || _vm.product.category === 'Women Bikini' || _vm.product.category === 'Women Boys Shorts' || _vm.product.category === ' Women Hipster Underwear') ? 'collapse' : 'collapse show',
    attrs: {
      "id": "collapseOne",
      "aria-expanded": "false",
      "role": "tabpanel",
      "aria-labelledby": "headingOne"
    }
  }, [_c('div', {
    ref: "descBlock",
    staticClass: "card-block",
    on: {
      "click": _vm.handleCertificateClick
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.add_desc)
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.product.short_desc) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingTwo"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheading"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseTwo",
      "aria-expanded": "false",
      "aria-controls": "collapseTwo"
    },
    on: {
      "click": _vm.productDescription
    }
  }, [_vm._v("\n                    Product Description\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "role": "tabpanel",
      "aria-labelledby": "headingTwo"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.short_desc)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.product.user_description) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingArtist"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheading"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseArtist",
      "aria-expanded": "false",
      "aria-controls": "collapseArtist"
    },
    on: {
      "click": _vm.artistDetails
    }
  }, [_vm._v("\n                    Artist's Details\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseArtist",
      "role": "tabpanel",
      "aria-labelledby": "headingArtist"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.user_description)
    }
  })])])])]) : _vm._e()]), _vm._v(" "), (_vm.bannerPlaceHolderReviewSection && _vm.product.avg_product_rating > 0) ? _c('div', [_c('ReviewModal', {
    attrs: {
      "avgRating": _vm.product.avg_product_rating,
      "productId": this.product.id
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), (!_vm.isTssCorpProduct) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [(_vm.showFrequentlyBoughtListing && _vm.frequentlyBoughtPdpListing && _vm.frequentlyBoughtPdpListing.data && _vm.frequentlyBoughtPdpListing.data.length && _vm.product.images) ? _c('div', {
    staticClass: "pb-3 pdp-slider-listing",
    style: ({
      order: _vm.checkIsNumber(_vm.showFrequentlyBoughtListing.model_position)
    })
  }, [_c('div', {
    staticClass: "seperator pb-3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "widget-heading fbold",
    class: !_vm.$parent.isDesktop ? 'px-3' : '',
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.showFrequentlyBoughtListing.tag_text || 'Frequently Bought Products'))]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    staticClass: "bannerview pdpcarouselview",
    attrs: {
      "navigationEnabled": _vm.$parent.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 4],
        [1920, 4]
      ],
      "perPage": _vm.$parent.isDesktop ? 4 : 2.5
    }
  }, _vm._l((_vm.frequentlyBoughtPdpListing.data), function(prm, index) {
    return _c('slide', {
      key: prm.id,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "alsoavail vueCaraSlidr"
    }, [_c('img-block', {
      attrs: {
        "parry": prm.images,
        "position": index,
        "isExclusive": _vm.isExclusive,
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.product_slug,
        "productTitle": prm.product,
        "productCat": prm.artist.name,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusivePrice,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice || prm.spl_price,
        "listCat": prm.category.name,
        "genderType": prm.genderType,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "scrollToProduct": _vm.scrollNow,
        "prodType": prm.prodType,
        "togglePopup": _vm.togglePopup,
        "imageCount": _vm.frequentlyBoughtPdpListing.data.length,
        "showImageBlurSoldOutDesign": true,
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "prm": prm,
        "headingTitle": _vm.showFrequentlyBoughtListing.tag_text || 'Frequently Bought Products'
      },
      nativeOn: {
        "click": function($event) {
          _vm.frequentlyBoughtPdpEventHandler(prm)
        }
      }
    })], 1)])
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.productRecommData && Object.keys(_vm.productRecommData).length && _vm.product.images) ? _c('div', {
    attrs: {
      "id": "crossSellProducts"
    }
  }, _vm._l((_vm.productRecommData), function(widget, widgetKey, index) {
    return _c('div', {
      key: index
    }, [(widget && widget.length && _vm.bannerPlaceHolderForProductRecommData && _vm.bannerPlaceHolderForProductRecommData.includes(widgetKey)) ? _c('div', [(!_vm.$parent.isDesktop) ? _c('div', {
      staticClass: "seperator pb-3"
    }) : _vm._e(), _vm._v(" "), _c('h3', {
      staticClass: "widget-heading fbold",
      class: !_vm.$parent.isDesktop ? 'px-3' : '',
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(_vm.productRecommTitleMapping && _vm.productRecommTitleMapping[widgetKey]))]), _vm._v(" "), _c('carousel', {
      attrs: {
        "perPage": 2.5,
        "navigationEnabled": true,
        "paginationEnabled": false,
        "navigationNextLabel": " ",
        "navigationPrevLabel": " ",
        "autoplay": false,
        "perPageCustom": [
          [480, 2.5],
          [768, 3],
          [1200, 4]
        ]
      }
    }, _vm._l((widget), function(prm, index) {
      return _c('slide', {
        key: prm.id,
        staticClass: "col-md-3 col-6"
      }, [_c('div', {
        staticClass: "alsoavail vueCaraSlidr"
      }, [_c('img-block', {
        attrs: {
          "parry": prm.imageUrl,
          "position": index,
          "isExclusive": _vm.isExclusive,
          "index": index,
          "urlKey": prm.product_slug,
          "productTitle": prm.product,
          "productPrice": prm.price,
          "exclusivePrice": prm.exclusive_price,
          "jitValue": prm.jitValue,
          "productCat": prm.artist,
          "pstock": prm.stock,
          "spprice": prm.spl_price,
          "listCat": prm.category && prm.category[0],
          "genderType": prm.gender_type,
          "pclass": 'prd' + prm.id + prm.category + 'img',
          "product": prm,
          "isStockConfig": prm.prod_qty,
          "scrollToProduct": _vm.scrollNow,
          "prodType": prm.prod_type,
          "togglePopup": _vm.togglePopup,
          "showImageBlurSoldOutDesign": true,
          "headingTitle": _vm.productRecommTitleMapping && _vm.productRecommTitleMapping[widgetKey]
        }
      })], 1)])
    }))], 1) : _vm._e()])
  })) : (_vm.showSimilarProductDetails && _vm.crossSellItems && _vm.crossSellItems.length > 0 && _vm.product.images) ? _c('div', {
    staticClass: "pb-3 pdp-slider-listing",
    style: ({
      order: _vm.checkIsNumber(_vm.showSimilarProductDetails.model_position)
    }),
    attrs: {
      "id": "crossSellProducts"
    }
  }, [_c('div', {
    staticClass: "seperator pb-3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "widget-heading fbold",
    class: !_vm.$parent.isDesktop ? 'px-3' : '',
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.showSimilarProductDetails.tag_text || 'Similar Products'))]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    staticClass: "bannerview pdpcarouselview",
    attrs: {
      "navigationEnabled": _vm.$parent.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 4],
        [1920, 4]
      ],
      "perPage": _vm.$parent.isDesktop ? 4 : 2.5
    }
  }, _vm._l((_vm.crossSellItems), function(prm, index) {
    return _c('slide', {
      key: prm.id,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "alsoavail vueCaraSlidr"
    }, [_c('img-block', {
      attrs: {
        "parry": prm.images,
        "position": index,
        "isExclusive": _vm.isExclusive,
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.product_slug,
        "productTitle": prm.product,
        "productCat": prm.artist.name,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusivePrice,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice || prm.spl_price,
        "listCat": prm.category.name,
        "genderType": prm.genderType,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "scrollToProduct": _vm.scrollNow,
        "prodType": prm.prodType,
        "togglePopup": _vm.togglePopup,
        "imageCount": _vm.crossSellItems.length,
        "showImageBlurSoldOutDesign": true,
        "callerComp": _vm.crossSellName || 'Similar Products',
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "prm": prm,
        "headingTitle": _vm.showSimilarProductDetails.tag_text || 'Similar Products'
      },
      nativeOn: {
        "click": function($event) {
          _vm.crossSellEventHandler(prm)
        }
      }
    })], 1)])
  }))], 1)]) : _vm._e(), _vm._v(" "), (true && _vm.visenzeSearchItem.products && _vm.visenzeSearchItem.products.length && _vm.isSelectedCountryIndia && _vm.enableVincenzeSearch) ? _c('div', {
    staticClass: "pb-3 pdp-slider-listing",
    style: ({
      order: _vm.checkIsNumber(4)
    }),
    attrs: {
      "id": "visenzeSearchItem"
    }
  }, [_c('div', {
    staticClass: "seperator pb-3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "widget-heading fbold",
    class: !_vm.$parent.isDesktop ? 'px-3' : '',
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s('Recommended Products'))]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    staticClass: "bannerview pdpcarouselview",
    attrs: {
      "navigationEnabled": _vm.$parent.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 4],
        [1920, 4]
      ],
      "perPage": _vm.$parent.isDesktop ? 4 : 2.5
    }
  }, _vm._l((_vm.visenzeSearchItem.products), function(prm, index) {
    return _c('slide', {
      key: prm.id,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "alsoavail vueCaraSlidr"
    }, [_c('img-block', {
      attrs: {
        "parry": prm.images,
        "position": index,
        "isExclusive": _vm.isExclusive,
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.product_slug,
        "productTitle": prm.product,
        "productCat": prm.artist.name,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusivePrice,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice || prm.spl_price,
        "listCat": prm.category.name,
        "genderType": prm.genderType,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "scrollToProduct": _vm.scrollNow,
        "prodType": prm.prodType,
        "togglePopup": _vm.togglePopup,
        "imageCount": _vm.visenzeSearchItem.length,
        "showImageBlurSoldOutDesign": true,
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "prm": prm,
        "headingTitle": 'Recommended Products',
        "callerComp": "Recommended Products"
      },
      nativeOn: {
        "click": function($event) {
          _vm.crossSellPdpEventHandler(prm)
        }
      }
    })], 1)])
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.crossSellPdpListing && _vm.crossSellPdpListing.data && _vm.crossSellPdpListing.data.length && _vm.crossSellingPdpDetails && _vm.product.images) ? _c('div', {
    staticClass: "pb-3 pdp-slider-listing",
    style: ({
      order: _vm.checkIsNumber(_vm.crossSellingPdpDetails.model_position)
    }),
    attrs: {
      "id": "crossSellPdpListing"
    }
  }, [_c('div', {
    staticClass: "seperator pb-3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "widget-heading fbold",
    class: !_vm.$parent.isDesktop ? 'px-3' : '',
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.crossSellingPdpDetails.tag_text || 'You may also like'))]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    staticClass: "bannerview pdpcarouselview",
    attrs: {
      "navigationEnabled": _vm.$parent.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 4],
        [1920, 4]
      ],
      "perPage": _vm.$parent.isDesktop ? 4 : 2.5
    }
  }, _vm._l((_vm.crossSellPdpListing.data), function(prm, index) {
    return _c('slide', {
      key: prm.id,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "alsoavail vueCaraSlidr"
    }, [_c('img-block', {
      attrs: {
        "parry": prm.images,
        "position": index,
        "isExclusive": _vm.isExclusive,
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.product_slug,
        "productTitle": prm.product,
        "productCat": prm.artist.name,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusivePrice,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice || prm.spl_price,
        "listCat": prm.category.name,
        "genderType": prm.genderType,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "scrollToProduct": _vm.scrollNow,
        "prodType": prm.prodType,
        "togglePopup": _vm.togglePopup,
        "imageCount": _vm.crossSellPdpListing.data.length,
        "showImageBlurSoldOutDesign": true,
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "prm": prm,
        "headingTitle": _vm.crossSellingPdpDetails.tag_text || 'You may also like'
      },
      nativeOn: {
        "click": function($event) {
          _vm.crossSellPdpEventHandler(prm)
        }
      }
    })], 1)])
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.showPersonalizedWidgetListing && _vm.personalizedWidgetListing && _vm.personalizedWidgetListing.data && _vm.personalizedWidgetListing.data.length && _vm.authStatus && _vm.product.images) ? _c('div', {
    staticClass: "pb-3 pdp-slider-listing",
    style: ({
      order: _vm.checkIsNumber(_vm.showPersonalizedWidgetListing.model_position)
    }),
    attrs: {
      "id": "crossSellPdpListing"
    }
  }, [_c('div', {
    staticClass: "seperator pb-3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "widget-heading fbold",
    class: !_vm.$parent.isDesktop ? 'px-3' : '',
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.showPersonalizedWidgetListing.tag_text || 'Personalized products'))]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    staticClass: "bannerview",
    attrs: {
      "navigationEnabled": _vm.$parent.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 4],
        [1920, 4]
      ],
      "perPage": _vm.$parent.isDesktop ? 4 : 2.5
    }
  }, _vm._l((_vm.personalizedWidgetListing.data), function(prm, index) {
    return _c('slide', {
      key: prm.id,
      staticClass: "col"
    }, [_c('div', {
      staticClass: "alsoavail vueCaraSlidr"
    }, [_c('img-block', {
      attrs: {
        "parry": prm.images,
        "position": index,
        "isExclusive": _vm.isExclusive,
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.product_slug,
        "productTitle": prm.product,
        "productCat": prm.artist.name,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusivePrice,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice,
        "listCat": prm.category.name,
        "genderType": prm.genderType,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "scrollToProduct": _vm.scrollNow,
        "prodType": prm.prodType,
        "togglePopup": _vm.togglePopup,
        "imageCount": _vm.personalizedWidgetListing.data.length,
        "showImageBlurSoldOutDesign": true,
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "prm": prm,
        "headingTitle": _vm.showPersonalizedWidgetListing.tag_text || 'Personalized products'
      },
      nativeOn: {
        "click": function($event) {
          _vm.crossSellPdpEventHandler(prm)
        }
      }
    })], 1)])
  }))], 1)]) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), (_vm.prview) ? _c('product-view', {
    attrs: {
      "isDesktop": this.$parent.isDesktop,
      "imgArray": _vm.product.images,
      "videoUrl": _vm.prviewImage,
      "activeImg": _vm.magActiveimg
    },
    on: {
      "close": function($event) {
        _vm.prview = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isImageModal) ? _c('sizeimage-modal', {
    attrs: {
      "imageModalData": _vm.imageModalData
    },
    on: {
      "close": function($event) {
        _vm.isImageModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForMemberShipBanner) ? _c('MembershipPopUpBanner', {
    attrs: {
      "isVisible": _vm.isMembershipModalVisible,
      "bannerPlaceHolderForMemberShipBanner": _vm.bannerPlaceHolderForMemberShipBanner
    },
    on: {
      "close": _vm.closeMembershipPopup,
      "exclusiveMembershipAdded": _vm.handleExclusiveAdded
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "productAdded"
  }, [_vm._v("Product has been added to cart.")]), _vm._v(" "), (_vm.isNotifyVisible) ? _c('exclusive-modal', {
    attrs: {
      "addExclusive": _vm.addExclusive,
      "togglePopup": _vm.togglePopup,
      "exclusiveAdded": _vm.exclusiveAdded,
      "removeExcFromCart": _vm.removeExcFromCart,
      "memberSavings": _vm.product.price && _vm.product.exclusive_price && parseInt(_vm.product.price) - parseInt(_vm.product.exclusive_price)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCustomizedProdModal && _vm.imageModalData && Object.keys(_vm.imageModalData).length) ? _c('customized-prod-modal', {
    attrs: {
      "customizedProdData": _vm.imageModalData,
      "confirmCustomization": _vm.confirmCustomization,
      "prodPrintName": _vm.print_name,
      "prodPrintNumber": _vm.print_number,
      "artistSlug": _vm.product.artist_slug
    },
    on: {
      "close": function($event) {
        _vm.isCustomizedProdModal = false
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isHelp) ? _c('tssHelpDetails', {
    attrs: {
      "setPopup": _vm.helpDetails,
      "processData": _vm.processData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-185a2995"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/productdetails.vue
// module id = 2434
// module chunks = 13